var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubsetFontinSansCrRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Wed Jul 19 15:14:15 2023\n By Aleksey,,,\nCopyright (c) 2009 by Jos Buivenga. All rights reserved.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FontinSansCR-Regular",
    horizAdvX: 1024
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Fontin Sans CR",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 2048,
    panose1: "2 0 0 0 0 0 0 0 0 0",
    ascent: 1638,
    descent: -410,
    xHeight: 1008,
    capHeight: 1348,
    bbox: "-111 -520 2390 1800",
    underlineThickness: 102,
    underlinePosition: -307,
    unicodeRange: "U+0020-2122"
  }), /*#__PURE__*/React.createElement("missingGlyph", null), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ff",
    unicode: "ff",
    horizAdvX: 1343,
    d: "M879 868h-500v-657l20 -211h-192v868h-125v140h125v129q0 81 30 150.5t77 115.5t105.5 79t115 47.5t106.5 14.5q193 0 328 -86q80 86 207 86q116 0 235 -69l-68 -154q-74 61 -147 61q-64 0 -104.5 -49t-40.5 -139v-186h286l-61 -140h-225v-657l20 -211h-192v868z M879 1157q0 95 16 152q-115 86 -233 86q-121 0 -202 -72.5t-81 -169.5v-145h500v149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 1232,
    d: "M1038 1030v-876l21 -154h-193v821l-8 47h-479v-657l20 -211h-192v868h-125v140h125v129q0 81 29 150.5t74.5 115.5t102.5 79t112.5 47.5t105.5 14.5q71 0 136.5 -13.5t108.5 -33t75.5 -38.5t47.5 -33l15 -13l-70 -162q-5 6 -15.5 15.5t-42 34.5t-64 44t-80 34.5 t-91.5 15.5q-120 0 -196 -72t-76 -170v-145h461z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 1232,
    d: "M82 868v140h125v129q0 81 29 150.5t74.5 115.5t102.5 79t112.5 47.5t105.5 14.5q106 0 200 -33l207 -73v-1284l21 -154h-193v1325q-99 70 -215 70q-120 0 -196 -72t-76 -170v-145h287l-62 -140h-225v-657l20 -211h-192v868h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffi",
    unicode: "ffi",
    horizAdvX: 1904,
    d: "M1710 1032v-878l21 -154h-193v821l-8 47h-490v-657l21 -211h-193v868h-489v-657l20 -211h-192v868h-125v140h125v129q0 81 29 150.5t74.5 115.5t102.5 79t112.5 47.5t105.5 14.5q71 0 135.5 -13t110 -34t72.5 -37t48 -33q64 57 144 87t151 30t136.5 -13.5t108.5 -33 t75.5 -38.5t47.5 -33l15 -13l-69 -162q-5 6 -15.5 15.5t-42 34.5t-64 44t-80 34.5t-91.5 15.5q-120 0 -196.5 -72t-76.5 -170v-145h471zM868 1137q0 85 31 155q-133 103 -248 103q-120 0 -196 -72t-76 -170v-145h489v129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffl",
    unicode: "ffl",
    horizAdvX: 1904,
    d: "M379 868v-657l20 -211h-192v868h-125v140h125v129q0 81 29 150.5t74.5 115.5t102.5 79t112.5 47.5t105.5 14.5q212 0 358 -110q63 54 140.5 82t146.5 28q133 0 227 -33l207 -73v-1284l21 -154h-193v1325q-42 30 -110.5 50t-131.5 20q-120 0 -196 -72t-76 -170v-145h287 l-62 -140h-225v-657l20 -211h-192v868h-473zM852 1137q0 91 35 163q-117 95 -236 95q-120 0 -196 -72t-76 -170v-145h473v129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fj",
    unicode: "fj",
    horizAdvX: 1224,
    d: "M1038 1030v-1055q0 -211 -96 -341t-244 -132l-67 142q235 0 235 331v844l-8 49h-479v-657l20 -211h-192v868h-125v140h125v129q0 81 29 150.5t74.5 115.5t102.5 79t112.5 47.5t105.5 14.5q71 0 136.5 -13.5t108.5 -33t75.5 -38.5t47.5 -33l15 -13l-70 -162 q-5 6 -15.5 15.5t-42 34.5t-64 44t-80 34.5t-91.5 15.5q-120 0 -196 -72t-76 -170v-145h461z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 552
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 540,
    d: "M403 102q0 -54 -35.5 -91.5t-86.5 -37.5t-87 37.5t-36 91.5q0 51 36 88t87 37t86.5 -37t35.5 -88zM379 1548l-31 -1159l-137 -20l-27 970l-26 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 802,
    d: "M182 1112l-37 229l185 33l-2 -500l-150 -2zM510 1112l-37 229l184 33l-2 -500l-149 -2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 1441,
    d: "M1274 377h-303l-39 -377h-158l39 377h-299l-39 -377h-158l39 377h-297v131h312l41 381h-295v131h309l35 328h155l-34 -328h299l34 328h158l-35 -328h308l-17 -131h-303l-41 -381h305zM827 508l41 381h-299l-41 -381h299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 983,
    d: "M555 1546v-176q160 -9 293 -94l-53 -160q-12 9 -34 23t-85 41t-121 34v-440q138 -73 194 -118q141 -115 142 -285q0 -160 -90.5 -264.5t-245.5 -126.5v-173h-106v168q-62 3 -120 19t-95.5 37.5t-66 42t-41.5 34.5l-13 15l18 168q5 -6 15.5 -16.5t43.5 -37t68 -48 t87 -41.5t104 -25v483q-40 22 -54.5 30t-51.5 30t-52.5 33.5t-45.5 35t-44 40.5t-34 43t-29 50.5t-16 55t-7 63.5q0 144 93 251.5t241 129.5v178h106zM696 344q0 60 -37 107t-104 92v-412q64 21 102.5 76t38.5 137zM307 1042q0 -67 37 -116.5t105 -91.5v378 q-62 -15 -102 -58.5t-40 -111.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 1634,
    d: "M756 1038q0 -125 -94 -216t-220 -91q-123 0 -215 91t-92 216t92.5 216.5t214.5 91.5q125 0 219.5 -91.5t94.5 -216.5zM635 1042q0 74 -59 129.5t-132 55.5q-76 0 -132 -55t-56 -130q0 -74 54.5 -136t133.5 -62q86 0 138.5 61t52.5 137zM1524 281q0 -125 -94.5 -216.5 t-219.5 -91.5q-122 0 -214.5 91.5t-92.5 216.5t92 216t215 91q126 0 220 -91t94 -216zM1403 285q0 74 -59 129t-132 55q-77 0 -132.5 -54.5t-55.5 -129.5q0 -74 55 -136.5t133 -62.5q86 0 138.5 61.5t52.5 137.5zM1354 1325l-903 -1325h-166l934 1380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 1554,
    d: "M1384 -45q-157 53 -364 213q-80 -93 -197.5 -144t-261.5 -51q-183 0 -303.5 106.5t-120.5 291.5q0 64 22 124t65.5 114.5t88.5 98t109 93.5q-172 258 -172 405q0 156 103 248t282 92q156 0 247 -78t91 -206q0 -52 -21 -104.5t-49 -92.5t-80 -90.5t-89.5 -81.5t-102.5 -82 l-8 -6q162 -215 385 -416q43 85 65.5 181t22.5 272q0 44 -4 166h409l-41 -142h-219q2 -27 2 -78q0 -286 -127 -487q232 -186 387 -223zM629 115q77 0 152.5 37.5t133.5 101.5q-231 199 -417 444q-90 -78 -134.5 -143t-44.5 -139q0 -55 16 -105.5t50 -96t97 -72.5t147 -27z M422 1233q0 -126 133 -332q122 94 186 169t64 157q0 40 -18.5 80.5t-64.5 73t-110 32.5q-85 0 -137.5 -49.5t-52.5 -130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 475,
    d: "M182 1112l-37 229l185 33l-2 -500l-150 -2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 675,
    d: "M309 485q0 -154 28 -303t68 -254t85 -189t78.5 -127t49.5 -50l-120 -43q-99 56 -184 216t-132 361.5t-47 388.5t47.5 374.5t131.5 331.5t184 200l120 -43q-13 -6 -38.5 -33.5t-61.5 -76.5t-72 -124.5t-67 -165t-50.5 -211.5t-19.5 -252z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 675,
    d: "M367 485q0 130 -19.5 252t-51 211.5t-67.5 165t-72 124.5t-61.5 76.5t-38.5 33.5l121 43q100 -56 184 -200t131.5 -331.5t47.5 -374.5t-47 -388.5t-132 -361.5t-184 -216l-121 43q16 7 49.5 50t79 127t85.5 189t68 254t28 303z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 823,
    d: "M8 1124l62 127l237 -8l-151 262l131 11l121 -213l147 260l74 -111l-123 -209l301 8l-62 -127l-237 9l151 -263l-131 -10l-120 211l-148 -258l-74 111l121 209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 964,
    d: "M412 143v299h-293v152h293v305l143 -39v-266h305l-41 -152h-264v-299h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 552,
    d: "M197 -289l-74 72q42 40 78.5 99.5t36.5 105.5q0 39 -16 58.5t-58 37.5v18q0 55 34 92t89 37q51 0 87 -38t36 -109q0 -89 -55 -197t-158 -176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 618,
    d: "M63 582h506l-41 -152h-465v152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 552,
    d: "M399 102q0 -54 -36 -91.5t-87 -37.5t-86.5 37.5t-35.5 91.5q0 51 35.5 88t86.5 37t87 -37t36 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 595,
    d: "M532 1346l-442 -1846h-145l436 1846h151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    d: "M524 1204q101 0 177.5 -38t120.5 -97t71.5 -143.5t37 -164t9.5 -171.5q0 -103 -15 -192.5t-50 -168.5t-87.5 -135t-131 -88.5t-177.5 -32.5q-84 0 -153.5 35.5t-124 107.5t-85 193.5t-30.5 282.5q0 131 26 240t77.5 193t137 131.5t197.5 47.5zM512 1069q-120 0 -179 -119 t-59 -336q0 -116 10.5 -203.5t35.5 -159.5t71 -109.5t111 -37.5q117 0 185.5 129.5t68.5 348.5q0 487 -244 487z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 819,
    d: "M100 0v135h252v866l-213 -65l-51 125l436 145v-1071h254l-20 -135h-658z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    d: "M893 0h-715l-20 90q19 24 39 47q58 66 98.5 112.5t115 142t121 169t84 160.5t37.5 149q0 97 -55 150t-131 53q-62 0 -125.5 -32.5t-110.5 -86.5l-73 144q61 52 151 82t187 30q68 0 129.5 -20t111 -57.5t78.5 -98.5t29 -137q0 -73 -25 -153t-65 -150t-88 -137t-96.5 -120 t-88.5 -93.5t-65 -61.5l-25 -22h522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    d: "M817 936q0 -182 -235 -297q138 -18 216.5 -122t78.5 -232q0 -150 -85 -263.5t-228 -172t-320 -58.5q-49 0 -74 2l-43 139q29 -4 90 -4q83 0 161.5 18.5t149.5 56t114.5 106t43.5 157.5q0 78 -48 141t-119.5 96t-149.5 36l26 120q102 47 167 110t65 140q0 71 -51.5 116.5 t-122.5 45.5q-126 0 -234 -117l-74 144q58 46 147 77t179 31q145 0 245.5 -71.5t100.5 -198.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    d: "M61 285l562 923l153 -45v-829h201l-41 -160h-160v-225l21 -154h-193v379h-522zM608 334v516l10 119l-57 -129l-266 -455l-37 -51h350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    d: "M872 1178l-41 -160h-428l-10 -268q92 0 180 -31t158 -87t113 -142t43 -187q0 -105 -36 -191.5t-97.5 -145t-144 -98.5t-173.5 -58.5t-188 -18.5q-37 0 -55 2l-43 139q29 -4 94 -4q85 0 164.5 21t146 62t107 108.5t40.5 152.5q0 142 -109.5 243t-283.5 101l-73 -4l24 566 h612z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    d: "M584 862q71 0 135 -24.5t114.5 -72t80.5 -124.5t30 -174q0 -100 -29 -189t-82 -157t-136 -108t-185 -40q-110 0 -195 54t-135 146.5t-75 205t-25 239.5q0 191 42 337.5t117 236t172.5 134t213.5 44.5q81 0 164 -30t131 -87l-72 -139q-31 48 -97.5 81.5t-136.5 33.5 q-134 0 -229.5 -118t-116.5 -347q53 34 137.5 66t176.5 32zM547 119q100 0 155.5 88t55.5 203q0 151 -73 229t-187 78q-68 0 -131.5 -29.5t-100.5 -58.5q1 -100 15 -185.5t45 -161.5t87.5 -119.5t133.5 -43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    d: "M377 -227l-166 30l530 1215h-600l-61 160h864l31 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    d: "M483 -27q-52 0 -102.5 10t-101.5 34t-89 59t-62 90.5t-24 124.5q0 55 16.5 106t42 91t66 80.5t77 69.5t87.5 64q-114 89 -174.5 168t-60.5 172q0 143 103 235.5t276 92.5q155 0 248.5 -77.5t93.5 -194.5q0 -59 -19.5 -112t-56.5 -98t-75.5 -79.5t-90.5 -71.5 q69 -53 110 -88t89 -84.5t71 -98t23 -97.5q0 -173 -127 -284.5t-320 -111.5zM283 352q0 -110 59.5 -170.5t159.5 -60.5q95 0 172.5 57.5t77.5 138.5q0 39 -20 78t-65 83.5t-79.5 73.5t-102.5 81q-98 -67 -150 -132.5t-52 -148.5zM702 1042q0 83 -45.5 141t-142.5 58 q-84 0 -135 -45t-51 -121q0 -62 55 -125t158 -141q78 58 119.5 113.5t41.5 119.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    d: "M434 315q-150 0 -255 103t-105 293q0 134 48.5 244.5t148.5 179.5t235 69q110 0 195 -54t135 -146.5t75 -205t25 -239.5q0 -191 -42.5 -343.5t-116.5 -249.5t-172.5 -148t-213.5 -51q-82 0 -164.5 29.5t-130.5 86.5l72 140q32 -48 97.5 -81.5t135.5 -33.5 q130 0 228 136.5t119 369.5q-31 -20 -70.5 -39.5t-109.5 -39.5t-134 -20zM471 1059q-100 0 -155.5 -88t-55.5 -203q0 -151 73 -229t187 -78q68 0 131.5 29.5t100.5 58.5q-1 100 -15 185.5t-45 161.5t-87.5 119.5t-133.5 43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 528,
    d: "M395 668q0 -54 -36 -91.5t-87 -37.5t-86.5 37.5t-35.5 91.5q0 51 35.5 88t86.5 37t87 -37t36 -88zM395 102q0 -54 -36 -91.5t-87 -37.5t-86.5 37.5t-35.5 91.5q0 51 35.5 88t86.5 37t87 -37t36 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 528,
    d: "M395 668q0 -54 -36 -91.5t-87 -37.5t-86.5 37.5t-35.5 91.5q0 51 35.5 88t86.5 37t87 -37t36 -88zM178 -289l-74 72q42 40 78.5 99.5t36.5 105.5q0 39 -16 58.5t-58 37.5v18q0 55 34 92t89 37q51 0 87 -38t36 -109q0 -89 -55 -197t-158 -176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 755,
    d: "M659 844l-354 -340l354 -336l-79 -131l-498 469l498 469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 983,
    d: "M119 416h729l-41 -152h-688v152zM119 754h749l-41 -152h-708v152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 755,
    d: "M438 504l-354 340l80 131l498 -469l-498 -469l-80 131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 878,
    d: "M393 352l-164 54q-8 46 -8 69q0 64 21 123.5t54 106t73 91.5t80.5 89t73.5 88t54 98.5t21 112.5q0 83 -56.5 139.5t-160.5 56.5q-40 0 -90.5 -13t-82.5 -26t-32 -16l-70 166q121 59 275 59q185 0 300.5 -95t115.5 -247q0 -74 -23.5 -143t-60.5 -122.5t-82 -103.5t-90 -96 t-82 -90.5t-60.5 -96t-23.5 -103.5q0 -13 4.5 -38t8.5 -44zM467 102q0 -54 -38.5 -91.5t-92.5 -37.5t-92.5 37.5t-38.5 91.5q0 51 38.5 88t92.5 37t92.5 -37t38.5 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 1847,
    d: "M1245 852v-504q0 -105 8 -166t33 -82q82 1 149.5 70t103.5 178t36 230q0 185 -68.5 328t-209 228t-334.5 85q-143 0 -272 -67t-217.5 -175t-140.5 -245.5t-52 -276.5q0 -100 29 -198.5t86 -186t135 -156t184 -111t225 -47.5l-104 -143q-134 17 -250 72.5t-200 137 t-144 184t-89.5 215.5t-29.5 229q0 137 37.5 268.5t112 245t177.5 199.5t242.5 135t298.5 49q203 0 372.5 -92.5t268.5 -257.5t99 -367q0 -101 -21 -197t-64 -180.5t-103.5 -147.5t-146.5 -100t-186 -37q-19 0 -65 4q-23 24 -39 71.5t-19 94.5q-1 0 -14.5 -16t-37 -39.5 t-54 -46.5t-74 -39t-88.5 -16q-130 0 -225.5 119.5t-95.5 297.5q0 140 49 260.5t131 202t191 128t227 46.5q77 0 176 -30zM1071 240l-2 657q-9 0 -27 -2t-56.5 -13t-76.5 -29.5t-80.5 -55t-74.5 -85t-53 -125.5t-21 -171q0 -109 55.5 -189t138.5 -80q107 0 197 93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 1169,
    d: "M-4 0l520 1348l125 26l418 -1149l102 -225h-223l-129 352h-502l-133 -352h-178zM543 977l-181 -469h396l-170 471l-21 80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 1144,
    d: "M414 1204v-399h147q22 0 45 -1.5t40.5 -3.5t32 -4t23 -3.5t9.5 -1.5q77 103 77 206q0 108 -69 159.5t-217 51.5q-26 0 -88 -4zM203 1348l323 10q196 6 317.5 -78.5t121.5 -241.5q0 -126 -154 -280q54 -25 93 -52t72 -67t49.5 -95t16.5 -126q0 -86 -27 -158.5t-84 -132 t-157 -93.5t-235 -34h-310v1159zM414 653v-506h149q79 0 136.5 21.5t88.5 58.5t45.5 79.5t14.5 92.5q0 136 -78.5 195t-239.5 59h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 1263,
    d: "M1174 1204l-95 -139q-150 156 -344 156q-128 0 -231.5 -79.5t-159 -206t-55.5 -269.5q0 -120 40 -222.5t105 -169.5t147.5 -105t168.5 -38q52 0 112 17.5t108.5 43t89.5 51t64 43.5l23 17l45 -151q-8 -7 -23 -19t-63.5 -43t-101 -54.5t-131 -43t-156.5 -19.5 q-121 0 -232 44.5t-199 126.5t-141 212t-53 289q0 154 51.5 290t139 231.5t207.5 150.5t253 55q248 0 431 -168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 1368,
    d: "M713 1348q110 0 209 -41t179 -120t127.5 -209.5t47.5 -295.5q0 -191 -76 -346t-219.5 -245.5t-329.5 -90.5h-422v1159l-26 189h510zM676 1200h-262v-1053h262q114 0 206.5 71t143.5 190.5t51 261.5q0 144 -51 265t-143.5 193t-206.5 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    d: "M229 0v1159l-26 189h700v-152h-489v-430h428l-41 -152h-387v-462h512l-41 -152h-656z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 985,
    d: "M229 1159l-26 189h700v-152h-489v-430h428l-41 -152h-387v-460l20 -154h-205v1159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 1347,
    d: "M1182 666l2 -615q-8 -3 -23.5 -8.5t-65.5 -19t-101.5 -23.5t-127.5 -18.5t-149 -8.5q-121 0 -232 44.5t-199 126.5t-141 212t-53 289q0 206 85 373t231.5 260.5t324.5 93.5q258 0 441 -168l-95 -139q-150 156 -344 156q-93 0 -176.5 -47t-142 -123.5t-93 -177.5 t-34.5 -207q0 -120 40 -224.5t105.5 -173.5t148.5 -108t171 -39q49 0 111.5 8.5t100.5 17.5l38 9l2 358l-35 152h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 1546,
    d: "M1319 1348v-1194l20 -154h-204v614h-721v-460l20 -154h-205v1159l-26 189h211v-570h721v381l-27 189h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 638,
    d: "M414 1348v-1194l20 -154h-205v1159l-26 189h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 608,
    d: "M401 1348v-1270q0 -97 -23.5 -182.5t-71 -154.5t-126 -109t-180.5 -40q-44 0 -111 13l11 180q59 -27 100 -27q97 0 157 93.5t60 226.5v1081l-27 189h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 1183,
    d: "M1171 0h-243l-514 682v-528l20 -154h-205v1159l-26 189h211v-641l415 507l60 134h264l-532 -639z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 954,
    d: "M229 0v1159l-26 189h211v-1192h528l-41 -156h-672z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 1830,
    d: "M928 152l-475 653l-68 135v-786l21 -154h-189v1159l-27 189h136l610 -871l553 871h115v-1194l20 -154h-205v948l-71 -143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 1531,
    d: "M1325 1348v-1194l12 -154h-96l-768 860l-88 133v-839l21 -154h-189v1159l-27 189h125l752 -852l90 -134v797l-27 189h195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 1392,
    d: "M709 1372q145 0 258.5 -51.5t185.5 -144t109.5 -217t37.5 -273.5q0 -196 -81 -359.5t-223 -258.5t-314 -95q-137 0 -249.5 54.5t-186 148t-113 218.5t-39.5 268q0 146 47.5 277t128.5 226.5t195.5 151t243.5 55.5zM295 674q0 -152 49.5 -278t142.5 -200.5t211 -74.5 t210.5 74.5t142 200.5t49.5 278t-49.5 278t-142 200.5t-210.5 74.5t-211 -74.5t-142.5 -200.5t-49.5 -278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 1118,
    d: "M203 1348h381q69 0 132.5 -15.5t120 -48.5t98.5 -80t66.5 -114.5t24.5 -147.5q0 -178 -147.5 -308t-364.5 -130h-100v-350l20 -154h-205v1159zM414 655h133q118 0 201 79.5t83 207.5q0 121 -81.5 187.5t-202.5 66.5h-133v-541z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 1392,
    d: "M709 1372q145 0 258.5 -51.5t185.5 -144t109.5 -217t37.5 -273.5q0 -276 -154 -475.5t-388 -230.5l454 -193l-77 -172l-492 233v129q-170 10 -296.5 104.5t-189.5 245t-63 335.5q0 146 47.5 277t128.5 226.5t195.5 151t243.5 55.5zM295 674q0 -152 49.5 -278 t142.5 -200.5t211 -74.5t210.5 74.5t142 200.5t49.5 278t-49.5 278t-142 200.5t-210.5 74.5t-211 -74.5t-142.5 -200.5t-49.5 -278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 1204,
    d: "M1184 0h-238l-360 506q-23 -2 -172 -2v-350l20 -154h-205v1159l-26 189h381q69 0 132.5 -15.5t120 -48.5t98.5 -80t66.5 -114.5t24.5 -147.5q0 -120 -70.5 -224t-191.5 -161zM414 655h133q114 0 199 85t85 202q0 121 -81.5 187.5t-202.5 66.5h-133v-541z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 983,
    d: "M111 125l20 176q6 -7 17.5 -19.5t48 -43.5t75 -54.5t96.5 -43t115 -19.5q92 0 155.5 60t63.5 163q0 54 -32.5 101t-84 82t-114.5 69t-125.5 71.5t-114 80.5t-84 104.5t-32.5 134.5q0 161 112 273t283 112q188 0 338 -96l-53 -150q-3 8 -40.5 30.5t-109 46.5t-141.5 24 q-78 0 -137.5 -50.5t-59.5 -134.5q0 -60 32 -108.5t83 -84t112.5 -68.5t123 -71t112.5 -82t83 -110t32 -147q0 -176 -111.5 -287t-296.5 -111q-68 0 -130.5 15.5t-103.5 38t-72.5 45t-45.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 1077,
    d: "M10 1192v156h1057v-156h-442v-1038l20 -154h-205v1192h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 1488,
    d: "M1100 516v643l-27 189h199v-809q0 -251 -151.5 -408.5t-401.5 -157.5q-99 0 -179.5 27t-130.5 68t-87.5 97t-55.5 104t-28.5 100.5t-12.5 76t-2 39.5v674l-26 189h211v-846q0 -163 99 -271t249 -108t247 114t97 279z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 1196,
    d: "M1194 1348l-530 -1375l-129 27l-408 1122l-119 226h246l321 -902l43 -172l54 172l340 902h182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1892,
    d: "M1892 1348l-530 -1375l-127 27l-244 668l-37 127l-34 -129l-267 -693l-114 27l-408 1122l-119 226h242l321 -902l43 -172l54 172l205 539l-138 363h211l322 -902l43 -172l53 172l340 902h184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 1017,
    d: "M18 0l400 684l-289 518l-106 146h239l240 -428l30 -64l27 64l244 428h192l-383 -648l394 -700h-220l-254 461l-30 67l-33 -71l-256 -457h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 1042,
    d: "M621 594v-440l20 -154h-205v594l-317 608l-107 146h238l266 -506l29 -82l39 86l268 502h184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 1159,
    d: "M74 0l-8 51l641 1016l90 123h-686l45 158h913l8 -52l-639 -1013l-94 -127h756v-156h-1026z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 526,
    d: "M489 1483v-127h-165v-1368h165v-129h-329v1624h329z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 729,
    d: "M590 -500l-580 1846h156l563 -1846h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 526,
    d: "M37 1356v127h330v-1624h-330v129h166v1368h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 1277,
    d: "M1128 655h-143q-98 180 -185 337.5t-125 224.5l-38 67q-127 -233 -348 -629h-144q103 180 211.5 379t165.5 308l58 108h114q405 -746 434 -795z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 921,
    d: "M979 -154l-61 -122h-914v122h975z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 692,
    d: "M74 1483h225l254 -293l-113 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 1036,
    d: "M231 745l-92 134q5 6 15.5 17t48 38t80.5 47.5t112.5 37.5t145.5 17q63 0 116 -14t97 -44t69 -82t25 -122v-543q0 -55 23 -112.5t46 -88.5l23 -30l-190 -27q-6 9 -16 24.5t-26.5 59.5t-17.5 84q-43 -66 -138 -117t-187 -51q-108 0 -186.5 71.5t-78.5 182.5 q0 169 160.5 274t415.5 105v74q0 115 -42.5 167t-111.5 52q-53 0 -102 -16t-82 -38.5t-58.5 -45t-37.5 -38.5zM440 121q61 0 129.5 41.5t106.5 85.5v227q-27 -1 -39.5 -1.5t-60 -6t-78 -13t-75 -24t-71.5 -38.5t-47 -56.5t-20 -77.5q0 -55 39.5 -96t115.5 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 1122,
    d: "M164 1526l198 22v-606q42 27 73 44t80 32.5t97 15.5q79 0 151 -31t130.5 -91.5t93.5 -160t35 -225.5q0 -147 -62.5 -273t-178.5 -203t-259 -77q-111 0 -205.5 46.5t-126.5 111.5v1206zM362 809v-627q32 -33 84 -54.5t109 -21.5q113 0 194.5 120t81.5 282 q0 158 -76.5 273.5t-189.5 115.5q-42 0 -92.5 -22t-80.5 -42.5t-30 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 983,
    d: "M907 895l-108 -137q-96 137 -230 137q-89 0 -156 -54.5t-99.5 -139t-32.5 -183.5q0 -73 17.5 -140t51 -123.5t91 -90t130.5 -33.5q49 0 98.5 14.5t85.5 34.5t65 40.5t44 35.5l15 14l28 -155q-5 -6 -15.5 -15.5t-47 -34t-77.5 -43t-107.5 -34t-137.5 -15.5 q-97 0 -178.5 44t-133.5 117t-81 164t-29 187q0 110 30.5 208.5t88 176t149 123t205.5 45.5q216 0 334 -143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 1118,
    d: "M932 1546v-1315q0 -55 23 -112.5t46 -88.5l23 -30l-190 -27q-50 68 -60 150q-147 -150 -305 -150q-155 0 -262 136t-107 372q0 147 62.5 273t178.5 203t259 77q46 0 160 -12v313l-27 189zM535 113q55 0 114 35.5t111 101.5v637l-126 12q-39 2 -67 2q-113 0 -194.5 -119.5 t-81.5 -281.5q0 -173 70.5 -280t173.5 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 1007,
    d: "M557 1038q66 0 119.5 -20.5t88.5 -52t61.5 -77.5t40.5 -87.5t23 -93t11.5 -83t3.5 -67.5l-47 -53h-571q2 -72 19.5 -136.5t51 -118.5t89.5 -86t128 -32q49 0 100 14.5t89 34.5t69 40.5t47 35.5l17 14l29 -155q-6 -6 -17.5 -15.5t-50 -34t-82 -43t-111.5 -34t-139 -15.5 q-97 0 -178.5 44t-133.5 117t-81 164t-29 187q0 111 27.5 208.5t81 175.5t142.5 123.5t202 45.5zM532 905q-182 0 -235 -270h422q-3 45 -12.5 87.5t-29.5 86t-57.5 70t-87.5 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 671,
    d: "M82 868v140h125v149q0 199 83.5 293t213.5 94q116 0 235 -69l-67 -154q-74 61 -148 61q-64 0 -104.5 -49t-40.5 -139v-186h287l-62 -140h-225v-657l20 -211h-192v868h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 1058,
    d: "M502 242q-80 0 -154 28q-57 -71 -57 -114q0 -34 38 -49t99 -17t135 -1.5t148 -8t135 -30t99 -74t38 -134.5q0 -79 -42.5 -145t-112 -107.5t-155 -64.5t-175.5 -23q-104 0 -186 22.5t-125 54t-71 63.5t-36 54l-8 23l127 117q36 -103 125 -153t196 -50q115 0 197 47.5 t82 114.5q0 50 -36 77t-93.5 33.5t-127 7t-139 5t-127 20t-93.5 59.5t-36 116q0 57 36 112t79 94q-65 53 -104 134t-39 176q0 178 118 293.5t306 115.5q59 0 107.5 -14t67.5 -28l19 -15l37 27h268l-41 -140h-163q67 -83 67 -211q0 -102 -33.5 -183t-90.5 -130.5 t-128.5 -75.5t-150.5 -26zM297 639q0 -111 65 -190.5t152 -79.5t149 79t62 191t-62.5 192t-148.5 80q-87 0 -152 -80t-65 -192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 1183,
    d: "M1022 0h-193v590q0 157 -29.5 222t-119.5 65q-60 0 -114.5 -15.5t-89 -38t-60.5 -45t-38 -38.5l-11 -15v-571l20 -154h-192v1335l-27 189l199 22v-669q65 71 165.5 115t200.5 44q110 0 189 -62.5t79 -178.5v-645z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 561,
    d: "M164 1313q0 43 31 74.5t75 31.5q42 0 73.5 -31.5t31.5 -74.5t-32 -77t-73 -34q-43 0 -74.5 33.5t-31.5 77.5zM367 1030v-876l20 -154h-192v819l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 552,
    d: "M164 1313q0 43 31 74.5t75 31.5q42 0 73.5 -31.5t31.5 -74.5t-32 -77t-73 -34q-43 0 -74.5 33.5t-31.5 77.5zM367 1030v-1055q0 -211 -96 -341t-244 -132l-68 142q236 0 236 331v844l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 1046,
    d: "M1042 0h-233l-442 535v-381l20 -154h-192v1335l-27 189l199 22v-989l329 350l56 101h260l-455 -443z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 561,
    d: "M367 1546v-1392l20 -154h-192v1335l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 1810,
    d: "M1022 0h-193v590q0 157 -29.5 222t-119.5 65q-60 0 -114.5 -15.5t-89 -38t-60.5 -45t-38 -38.5l-11 -15v-571l20 -154h-192v819l-27 189l199 22v-153q65 71 165.5 115t200.5 44q86 0 156 -41.5t98 -117.5q65 71 165.5 115t201.5 44q110 0 189 -62.5t79 -178.5v-645 l20 -150h-192v590q0 62 -3.5 105t-13 80t-26 58t-43 32.5t-64.5 11.5q-178 0 -299 -134v-593z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 1189,
    d: "M1022 0h-193v590q0 157 -29.5 222t-119.5 65q-60 0 -114.5 -15.5t-89 -38t-60.5 -45t-38 -38.5l-11 -15v-571l20 -154h-192v819l-27 189l199 22v-153q65 71 165.5 115t200.5 44q110 0 189 -62.5t79 -178.5v-645z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 1132,
    d: "M100 487q0 242 136.5 396.5t365.5 154.5q193 0 311.5 -130.5t118.5 -381.5q0 -149 -58 -273.5t-174 -202t-268 -77.5q-86 0 -156.5 27.5t-114 68t-76.5 97t-48.5 105t-24.5 101t-10.5 76t-1.5 39.5zM289 506q0 -167 75.5 -281t200.5 -114q126 0 202.5 114.5t76.5 280.5 t-76.5 280.5t-202.5 114.5q-125 0 -200.5 -114t-75.5 -281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 1132,
    d: "M195 -492v1311l-27 189l199 22v-121q4 5 11.5 13.5t35 30t58 38t81 30t104.5 13.5q155 0 262 -136t107 -372q0 -147 -62.5 -273t-178.5 -203t-259 -77q-36 0 -159 13v-324l20 -154h-192zM367 121l121 -12q41 -3 71 -3q113 0 195 120t82 282q0 171 -67.5 276t-170.5 105 q-38 0 -76 -13.5t-65 -33.5t-48 -39.5t-31 -32.5l-11 -14v-635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 1107,
    d: "M948 -492h-188v555q-138 -90 -250 -90q-79 0 -151 32t-130.5 93t-93.5 161t-35 226q0 147 62.5 273t178.5 203t259 77q54 0 137 -8.5t139 -17.5l56 -8v-1307zM760 184v701q-121 20 -193 20q-113 0 -194.5 -119.5t-81.5 -281.5t81.5 -282t194.5 -120q102 0 193 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 794,
    d: "M815 981l-70 -168q-49 43 -104 43q-101 0 -187.5 -100.5t-86.5 -233.5v-368l20 -154h-192v819l-27 189l199 22v-225q17 30 30.5 52t44.5 59t63 61t80 42.5t101 18.5q75 0 129 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 874,
    d: "M111 92l18 166q5 -6 14 -15t38.5 -32.5t61 -41.5t80 -33t97.5 -15q81 0 130.5 32.5t49.5 104.5q0 37 -27.5 68t-71.5 54.5t-97.5 47t-107 51.5t-97.5 61.5t-71.5 84t-27.5 112.5q0 136 97 218.5t245 82.5q181 0 295 -69l-49 -164q-100 102 -262 102q-63 0 -107.5 -35 t-44.5 -86q0 -44 27.5 -79t71.5 -59t97.5 -47t107 -50t97.5 -60.5t71.5 -86t27.5 -119.5q0 -138 -97.5 -225t-258.5 -87q-59 0 -112 12.5t-87 30t-59.5 34.5t-37.5 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 751,
    d: "M397 1214l-20 -206h313l-61 -140h-252v-600q0 -68 30.5 -99.5t81.5 -31.5q59 0 121 23t101 61l28 -155q-117 -93 -290 -93q-108 0 -176 76.5t-68 235.5v583h-125v140h125v184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 1177,
    d: "M834 152q-60 -76 -169.5 -127.5t-211.5 -51.5q-110 0 -189.5 63t-79.5 179v604l-26 189l198 22v-610q0 -62 3.5 -105t13 -80t26 -58t43 -32.5t64.5 -11.5q60 0 114.5 16t89 38.5t60.5 45t38 38.5l11 16v532l-26 189l198 22v-799q0 -55 23 -112.5t46 -88.5l23 -30 l-190 -27q-7 10 -16.5 26.5t-26 63.5t-16.5 89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 972,
    d: "M961 1034l-424 -1061l-154 27l-281 838l-90 170l201 26l236 -682l30 -149l43 149l258 656z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 1654,
    d: "M1642 1034l-423 -1061l-144 27l-246 721l-303 -748l-143 27l-281 838l-90 170l195 26l237 -682l31 -147l43 147l227 578l-40 78l198 26l234 -684l28 -145l43 147l258 656z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 913,
    d: "M911 1034l-348 -485l350 -549h-213l-215 350l-30 60l-29 -60l-240 -350h-186l373 530l-211 332l-127 146l219 26l199 -313l20 -51l31 51l201 287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 972,
    d: "M961 1034l-484 -1206q-63 -157 -161.5 -241.5t-209.5 -84.5q-45 0 -106 23l-29 174q61 -21 105 -21q83 0 153 54.5t111 163.5l43 112l-281 830l-90 170l201 26l240 -682l26 -149l43 149l258 656z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 919,
    d: "M57 0l-6 39l475 745l64 84h-512l41 140h723l6 -39l-471 -746l-64 -84h545v-139h-801z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 561,
    d: "M35 559v107q42 0 74 14.5t47.5 33.5t25 44.5t11.5 41t2 29.5v412q0 150 91.5 227.5t237.5 77.5v-127q-166 0 -166 -184v-404q0 -37 -9.5 -73.5t-23.5 -61.5t-28 -45t-23 -29l-10 -10q4 -4 10 -10.5t22.5 -28.5t29 -45.5t22.5 -60.5t10 -74v-577q0 -185 166 -185v-127 q-146 0 -237.5 78t-91.5 228v585q0 14 -2 29.5t-11.5 41t-25 45t-47.5 34t-74 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 464,
    d: "M305 1548v-2068h-145v2068h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 561,
    d: "M526 666v-107q-42 0 -73.5 -14.5t-47.5 -34t-25 -45t-11 -41t-2 -29.5v-585q0 -150 -92 -228t-238 -78v127q166 0 166 185v577q0 37 9.5 73.5t23.5 61.5t28 45t24 29l9 10q-4 4 -10 10.5t-22.5 28.5t-29 45.5t-22.5 60.5t-10 74v404q0 184 -166 184v127q146 0 238 -77.5 t92 -227.5v-412q0 -14 2 -29.5t11 -41t25 -44.5t47.5 -33.5t73.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 1183,
    d: "M1083 551q-124 -127 -280 -127q-67 0 -132 20.5t-107.5 45t-97.5 45t-106 20.5q-99 0 -200 -88l-60 125q129 113 275 113q68 0 130.5 -20.5t102 -45.5t95.5 -45.5t112 -20.5q97 0 207 99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 540,
    d: "M137 1245q0 54 36 91.5t87 37.5t87 -37.5t36 -91.5q0 -51 -36 -88t-87 -37t-87 37t-36 88zM162 -201l31 1159l137 21l26 -971l27 -182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 966,
    d: "M612 1198v-162q189 -9 299 -141l-84 -119q-23 36 -95 80t-120 45v-764q45 4 89.5 19.5t75.5 35.5t56 39t37 32l13 13l28 -161q-4 -4 -12.5 -11.5t-38 -27t-61.5 -36t-83 -33.5t-104 -25v-175h-106v166q-76 2 -142 32t-113 79t-80.5 114t-50 138t-16.5 149q0 135 44 250.5 t137 197t221 99.5v166h106zM289 518q0 -130 56 -234.5t161 -136.5v748q-69 -20 -119 -78.5t-74 -135.5t-24 -163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 1124,
    d: "M1042 -209h-958q7 14 17.5 39t38 103t48.5 156t38.5 188t17.5 210v72h-125v139h125v439q0 81 29 150.5t74.5 115.5t102.5 79t112.5 47.5t105.5 14.5q71 0 136.5 -13.5t108.5 -33t75.5 -38.5t47.5 -33l15 -13l-70 -162q-5 6 -15.5 15.5t-42 34.5t-64 44t-80 34.5 t-91.5 15.5q-120 0 -193 -72t-73 -170v-455h424l-62 -139h-362v-90q0 -138 -24 -269.5t-48 -193.5l-24 -63h757z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 1064,
    d: "M203 754h180l-233 448l-127 146h258l299 -568l303 568h178l-334 -594h225l-41 -140h-260v-198h281l-41 -140h-240v-122l21 -154h-205v276h-264v140h264v198h-264v140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 860,
    d: "M553 1401q215 -1429 215 -1434q0 -153 -116 -243.5t-281 -90.5q-72 0 -128.5 14t-86 33.5t-48 39t-23.5 33.5l-5 14l8 133q51 -60 120.5 -90.5t145.5 -30.5q-217 1402 -217 1431q0 152 117 244t281 92q72 0 128.5 -13.5t85.5 -33t47.5 -39.5t23.5 -34l5 -13l-8 -133 q-51 59 -121.5 90t-142.5 31zM483 -203q150 48 150 172q0 22 -213 1413q-150 -45 -150 -172q0 -9 213 -1413z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 786,
    d: "M311 1292q0 -47 -30 -79.5t-72 -32.5t-72.5 32.5t-30.5 79.5q0 46 31 79.5t72 33.5t71.5 -33.5t30.5 -79.5zM688 1292q0 -47 -30 -79.5t-72 -32.5t-72.5 32.5t-30.5 79.5q0 46 31 79.5t72 33.5t71.5 -33.5t30.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 1617,
    d: "M1073 950l-76 -106q-64 90 -176 90q-90 0 -141 -73t-51 -181q0 -69 20.5 -126.5t68 -96.5t113.5 -39q52 0 106.5 27.5t82.5 54.5l29 28l24 -135q-4 -4 -12.5 -11t-36.5 -25t-59.5 -32t-81.5 -25t-103 -11q-94 0 -165 55t-104.5 137t-33.5 176q0 80 22.5 151t65 127 t110 89t150.5 33q158 0 248 -107zM1505 698q0 -212 -90 -377t-256 -256.5t-383 -91.5q-191 0 -343 87.5t-236 239.5t-84 339q0 321 206 521t541 200q185 0 333 -87t230 -238t82 -337zM1378 672q0 255 -157.5 419t-403.5 164q-116 0 -221.5 -44.5t-183 -121.5t-123 -188 t-45.5 -237q0 -249 165 -415.5t412 -166.5q112 0 214 44.5t177.5 121.5t120.5 188t45 236z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 829,
    d: "M190 1141l-81 112q4 5 12 13t36.5 29t61.5 37t87.5 29t113.5 13q106 0 175 -47.5t69 -148.5v-408q0 -40 17 -82.5t35 -65.5l17 -22l-160 -22q-5 3 -13.5 10t-22.5 32.5t-15 55.5q-40 -40 -105.5 -69t-117.5 -29q-105 0 -162 59t-57 139q0 114 114.5 189t315.5 79v64 q0 83 -28 121.5t-72 38.5q-37 0 -73 -13t-61.5 -32t-45.5 -37.5t-30 -31.5zM348 692q41 0 86 28.5t76 61.5v170q-22 -2 -41 -4t-54 -8t-63 -17t-55.5 -26.5t-43 -40t-15.5 -55.5q0 -43 28 -76t82 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 1230,
    d: "M659 844l-354 -340l354 -336l-79 -131l-498 469l498 469zM1128 844l-354 -340l354 -336l-79 -131l-498 469l498 469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 2482,
    d: "M92 502l1079 356v-708zM2171 502q0 44 32 76t76 32q46 0 78.5 -32t32.5 -76q0 -46 -32.5 -78.5t-78.5 -32.5q-44 0 -76 32.5t-32 78.5zM1751 502q0 44 32.5 76t76.5 32q46 0 78 -32t32 -76q0 -46 -32 -78.5t-78 -32.5q-44 0 -76.5 32.5t-32.5 78.5zM1341 502 q0 44 32.5 76t76.5 32q46 0 78.5 -32t32.5 -76q0 -46 -32.5 -78.5t-78.5 -32.5q-44 0 -76.5 32.5t-32.5 78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 1617,
    d: "M1155 319h-164l-186 265h-57v-178q0 -16 10 -87h-152v613l-12 108h221q104 0 177 -58t73 -163q0 -64 -35 -119.5t-102 -85.5zM797 666q48 0 87.5 47.5t39.5 105.5t-39 96.5t-88 38.5h-49v-288h49zM1505 698q0 -212 -90 -377t-256 -256.5t-383 -91.5q-191 0 -343 87.5 t-236 239.5t-84 339q0 321 206 521t541 200q185 0 333 -87t230 -238t82 -337zM1378 672q0 255 -157.5 419t-403.5 164q-116 0 -221.5 -44.5t-183 -121.5t-123 -188t-45.5 -237q0 -249 165 -415.5t412 -166.5q112 0 214 44.5t177.5 121.5t120.5 188t45 236z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 686,
    d: "M102 1362h506l-41 -152h-465v152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 817,
    d: "M745 1180q0 -140 -104.5 -242t-243.5 -102q-136 0 -240 102t-104 242q0 139 103.5 240.5t240.5 101.5q139 0 243.5 -101t104.5 -241zM610 1184q0 82 -65 143.5t-146 61.5q-86 0 -148.5 -61t-62.5 -144q0 -84 61 -152.5t150 -68.5q96 0 153.5 67.5t57.5 153.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 964,
    d: "M412 287v299h-293v151h293v305l143 -38v-267h305l-41 -151h-264v-299h-143zM178 141h635l-41 -141h-594v141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 714,
    d: "M618 586h-501l-13 63q1 2 30 31t62.5 64t75.5 86t75 99.5t56 101.5t23 95q0 61 -30.5 95t-71.5 34q-95 0 -158 -73l-60 114q93 80 236 80q103 0 175.5 -57.5t72.5 -167.5q0 -55 -30 -121.5t-66.5 -116.5t-85.5 -103t-70.5 -72.5t-36.5 -32.5h330z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 714,
    d: "M584 1200q0 -59 -42.5 -111t-111.5 -73q76 -12 130 -64t54 -145q0 -63 -30.5 -109.5t-82 -73t-112 -39t-129.5 -12.5q-21 0 -44.5 2t-51 6t-41.5 5l-31 119q85 -17 129 -17q228 0 228 119q0 45 -34 77.5t-77.5 46t-87.5 13.5l16 82q156 66 156 156q0 82 -90 82 q-44 0 -86 -17t-62 -34l-20 -17l-55 104q41 33 103 54.5t126 21.5q100 0 173 -47t73 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 692,
    d: "M393 1483h225l-366 -334l-113 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 1062
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 1273,
    d: "M119 748q0 122 47.5 233.5t128 191.5t192 127.5t234.5 47.5h123v-1848h-123v647q-163 0 -302 80.5t-219.5 219t-80.5 301.5zM1100 1348v-1848h-123v1848h123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 528,
    d: "M381 502q0 -54 -36 -91.5t-87 -37.5t-87 37.5t-36 91.5q0 51 36 88t87 37t87 -37t36 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 823,
    d: "M289 -119l20 105h60q15 -20 46 -42t60.5 -40.5t58.5 -41t46.5 -54t17.5 -68.5q0 -106 -69 -163.5t-169 -57.5q-108 0 -196 63l49 101q22 -22 61.5 -35t81.5 -13q117 0 117 76q0 29 -28.5 55t-79 58.5t-76.5 56.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 614,
    d: "M98 586v94h162v543l-131 -41l-37 92l324 104v-698h159l-12 -94h-465z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 905,
    d: "M92 963q0 183 105 298t282 115q150 0 242 -98t92 -287q0 -174 -104.5 -293.5t-282.5 -119.5q-67 0 -121 20.5t-88 51t-59 72.5t-37 78.5t-19.5 76t-8.5 57t-1 29.5zM258 977q0 -124 53 -210.5t140 -86.5q88 0 141 86t53 211t-53 211t-141 86q-87 0 -140 -86.5t-53 -210.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 1230,
    d: "M926 504l-355 340l80 131l498 -469l-498 -469l-80 131zM457 504l-355 340l80 131l498 -469l-498 -469l-80 131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 1409,
    d: "M98 586v94h162v543l-131 -41l-37 92l324 104v-698h159l-12 -94h-465zM1186 1169l-676 -976h-129l700 1017zM729 145l356 537l134 -41v-457h143l-27 -110h-116v-90l12 -103h-164v193h-324zM1069 184v242l4 74l-33 -68l-149 -221l-29 -29l58 2h149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 1454,
    d: "M1358 -119h-502l-12 64q35 36 75 82.5t101.5 125.5t101 158.5t39.5 137.5q0 108 -98 108q-89 0 -158 -80l-59 115q93 80 235 80q101 0 174.5 -55.5t73.5 -151.5q0 -68 -41.5 -151.5t-99.5 -153t-95 -108t-53 -52.5h330zM1163 1169l-676 -976h-129l701 1017zM98 586v94 h162v543l-131 -41l-37 92l324 104v-698h159l-12 -94h-465z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 1384,
    d: "M1161 1169l-676 -976h-129l701 1017zM705 145l356 537l133 -41v-457h143l-26 -110h-117v-90l12 -103h-164v193h-323zM1044 184v242l5 74l-33 -68l-150 -221l-28 -29l57 2h149zM584 1200q0 -59 -42.5 -111t-111.5 -73q76 -12 130 -64t54 -145q0 -63 -30.5 -109.5t-82 -73 t-112 -39t-129.5 -12.5q-21 0 -44.5 2t-51 6t-41.5 5l-31 119q85 -17 129 -17q228 0 228 119q0 45 -34 77.5t-77.5 46t-87.5 13.5l16 82q156 66 156 156q0 82 -90 82q-44 0 -86 -17t-62 -34l-20 -17l-55 104q41 33 103 54.5t126 21.5q100 0 173 -47t73 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 878,
    d: "M485 995l164 -53q8 -46 8 -70q0 -64 -20.5 -123.5t-54 -106t-73.5 -91.5t-80 -88.5t-73.5 -87.5t-54 -98.5t-20.5 -112.5q0 -83 56.5 -140t160.5 -57q40 0 90.5 13.5t82 26.5t31.5 16l70 -166q-123 -60 -274 -60q-185 0 -300.5 95t-115.5 247q0 74 23.5 143t60.5 122.5 t82 103.5t90 96t82 91t60.5 96.5t23.5 103.5q0 13 -5 38t-9 43zM412 1245q0 54 38.5 91.5t92.5 37.5t92.5 -37.5t38.5 -91.5q0 -51 -38.5 -88t-92.5 -37t-92.5 37t-38.5 88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 1169,
    d: "M-4 0l520 1348l125 26l418 -1149l102 -225h-223l-129 352h-502l-133 -352h-178zM543 977l-181 -469h396l-170 471l-21 80zM260 1792h225l254 -293l-112 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 1169,
    d: "M-4 0l520 1348l125 26l418 -1149l102 -225h-223l-129 352h-502l-133 -352h-178zM543 977l-181 -469h396l-170 471l-21 80zM686 1792h225l-366 -334l-113 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 1169,
    d: "M-4 0l520 1348l125 26l418 -1149l102 -225h-223l-129 352h-502l-133 -352h-178zM543 977l-181 -469h396l-170 471l-21 80zM520 1792h127l254 -293l-108 -41l-211 191l-207 -191l-109 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 1169,
    d: "M-4 0l520 1348l125 26l418 -1149l102 -225h-223l-129 352h-502l-133 -352h-178zM543 977l-181 -469h396l-170 471l-21 80zM825 1686l88 -54q-20 -34 -28 -47.5t-28 -37.5t-38 -33.5t-48.5 -18t-68.5 -8.5q-52 0 -99.5 18.5t-86.5 37t-70 18.5q-56 0 -102 -68l-88 53 q20 35 28 48t28 37.5t38 34t48.5 18t68.5 8.5q47 0 93.5 -19.5t87.5 -39t73 -19.5q71 0 104 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 1169,
    d: "M-4 0l520 1348l125 26l418 -1149l102 -225h-223l-129 352h-502l-133 -352h-178zM543 977l-181 -469h396l-170 471l-21 80zM498 1602q0 -47 -30.5 -80t-72.5 -33t-72 33t-30 80q0 46 30.5 79t71.5 33t72 -33t31 -79zM874 1602q0 -47 -30 -80t-72 -33t-72 33t-30 80 q0 46 30.5 79t71.5 33t71.5 -33t30.5 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 1169,
    d: "M-4 0l520 1348l125 26l418 -1149l102 -225h-223l-129 352h-502l-133 -352h-178zM543 977l-181 -469h396l-170 471l-21 80zM770 1620q0 -73 -56 -126.5t-130 -53.5q-73 0 -128 53.5t-55 126.5t55 126.5t128 53.5q74 0 130 -53.5t56 -126.5zM694 1622q0 44 -33 76.5 t-75 32.5q-44 0 -76.5 -32.5t-32.5 -76.5q0 -43 32 -80t77 -37q49 0 78.5 36t29.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 1566,
    d: "M772 0v356h-444q-28 -59 -85 -178t-85 -178h-170l655 1348h803v-152h-490v-430h428l-41 -152h-387v-462h512l-41 -152h-655zM399 508h373v651l-14 96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 1263,
    d: "M1174 1204l-95 -139q-150 156 -344 156q-128 0 -231.5 -79.5t-159 -206t-55.5 -269.5q0 -120 40 -222.5t105 -169.5t147.5 -105t168.5 -38q52 0 112 17.5t108.5 43t89.5 51t64 43.5l23 17l45 -151q-8 -7 -23 -19t-63.5 -43t-101 -54.5t-131 -43t-156.5 -19.5 q-121 0 -232 44.5t-199 126.5t-141 212t-53 289q0 154 51.5 290t139 231.5t207.5 150.5t253 55q248 0 431 -168zM639 -119l20 105h60q15 -20 46 -42t60.5 -40.5t58.5 -41t46.5 -54t17.5 -68.5q0 -107 -69 -164t-168 -57q-109 0 -197 63l49 101q21 -21 61.5 -34.5t82.5 -13.5 q116 0 116 76q0 29 -28.5 55t-79 58.5t-76.5 56.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    d: "M229 0v1159l-26 189h700v-152h-489v-430h428l-41 -152h-387v-462h512l-41 -152h-656zM238 1792h225l254 -293l-113 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    d: "M229 0v1159l-26 189h700v-152h-489v-430h428l-41 -152h-387v-462h512l-41 -152h-656zM664 1792h225l-367 -334l-112 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    d: "M229 0v1159l-26 189h700v-152h-489v-430h428l-41 -152h-387v-462h512l-41 -152h-656zM498 1792h127l254 -293l-109 -41l-211 191l-207 -191l-108 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    d: "M229 0v1159l-26 189h700v-152h-489v-430h428l-41 -152h-387v-462h512l-41 -152h-656zM475 1602q0 -47 -30 -80t-72 -33t-72.5 33t-30.5 80q0 46 31 79t72 33t71.5 -33t30.5 -79zM852 1602q0 -47 -30 -80t-72 -33t-72.5 33t-30.5 80q0 46 31 79t72 33t71.5 -33t30.5 -79z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 638,
    d: "M414 1348v-1194l20 -154h-205v1159l-26 189h211zM2 1792h225l254 -293l-112 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 638,
    d: "M414 1348v-1194l20 -154h-205v1159l-26 189h211zM428 1792h225l-366 -334l-113 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 638,
    d: "M414 1348v-1194l20 -154h-205v1159l-26 189h211zM262 1792h127l254 -293l-108 -41l-211 191l-207 -191l-109 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 638,
    d: "M414 1348v-1194l20 -154h-205v1159l-26 189h211zM240 1602q0 -47 -30.5 -80t-72.5 -33t-72 33t-30 80q0 46 30.5 79t71.5 33t72 -33t31 -79zM616 1602q0 -47 -30 -80t-72 -33t-72 33t-30 80q0 46 30.5 79t71.5 33t71.5 -33t30.5 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 1390,
    d: "M82 766h170v393l-27 189h510q110 0 209 -41t179 -120t127.5 -209.5t47.5 -295.5q0 -143 -44.5 -268t-124 -216.5t-197.5 -144.5t-258 -53h-422v614h-170v152zM698 1219h-262v-453h275l-41 -152h-234v-477h262q85 0 160.5 43.5t128 116t83 170t30.5 203.5q0 144 -51 269.5 t-144.5 202.5t-206.5 77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 1531,
    d: "M1325 1348v-1194l12 -154h-96l-768 860l-88 133v-839l21 -154h-189v1159l-27 189h125l752 -852l90 -134v797l-27 189h195zM1001 1686l89 -54q-20 -34 -28 -47.5t-28 -37.5t-38 -33.5t-48.5 -18t-68.5 -8.5q-52 0 -99.5 18.5t-86.5 37t-70 18.5q-57 0 -103 -68l-88 53 q20 35 28 48t28 37.5t38 34t48.5 18t68.5 8.5q47 0 93.5 -19.5t87.5 -39t73 -19.5q71 0 104 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 1392,
    d: "M709 1372q145 0 258.5 -51.5t185.5 -144t109.5 -217t37.5 -273.5q0 -196 -81 -359.5t-223 -258.5t-314 -95q-137 0 -249.5 54.5t-186 148t-113 218.5t-39.5 268q0 146 47.5 277t128.5 226.5t195.5 151t243.5 55.5zM295 674q0 -152 49.5 -278t142.5 -200.5t211 -74.5 t210.5 74.5t142 200.5t49.5 278t-49.5 278t-142 200.5t-210.5 74.5t-211 -74.5t-142.5 -200.5t-49.5 -278zM371 1792h225l254 -293l-113 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 1392,
    d: "M709 1372q145 0 258.5 -51.5t185.5 -144t109.5 -217t37.5 -273.5q0 -196 -81 -359.5t-223 -258.5t-314 -95q-137 0 -249.5 54.5t-186 148t-113 218.5t-39.5 268q0 146 47.5 277t128.5 226.5t195.5 151t243.5 55.5zM295 674q0 -152 49.5 -278t142.5 -200.5t211 -74.5 t210.5 74.5t142 200.5t49.5 278t-49.5 278t-142 200.5t-210.5 74.5t-211 -74.5t-142.5 -200.5t-49.5 -278zM797 1792h225l-367 -334l-112 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 1392,
    d: "M709 1372q145 0 258.5 -51.5t185.5 -144t109.5 -217t37.5 -273.5q0 -196 -81 -359.5t-223 -258.5t-314 -95q-137 0 -249.5 54.5t-186 148t-113 218.5t-39.5 268q0 146 47.5 277t128.5 226.5t195.5 151t243.5 55.5zM295 674q0 -152 49.5 -278t142.5 -200.5t211 -74.5 t210.5 74.5t142 200.5t49.5 278t-49.5 278t-142 200.5t-210.5 74.5t-211 -74.5t-142.5 -200.5t-49.5 -278zM631 1792h127l254 -293l-109 -41l-211 191l-207 -191l-108 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 1392,
    d: "M709 1372q145 0 258.5 -51.5t185.5 -144t109.5 -217t37.5 -273.5q0 -196 -81 -359.5t-223 -258.5t-314 -95q-137 0 -249.5 54.5t-186 148t-113 218.5t-39.5 268q0 146 47.5 277t128.5 226.5t195.5 151t243.5 55.5zM295 674q0 -152 49.5 -278t142.5 -200.5t211 -74.5 t210.5 74.5t142 200.5t49.5 278t-49.5 278t-142 200.5t-210.5 74.5t-211 -74.5t-142.5 -200.5t-49.5 -278zM936 1716l88 -53q-20 -34 -28 -47.5t-28 -37.5t-38 -33.5t-48.5 -18t-68.5 -8.5q-53 0 -100 18t-86 36.5t-70 18.5q-57 0 -102 -67l-88 53q20 34 28 47.5t28 37.5 t38 33.5t48.5 18t68.5 8.5q37 0 75 -12t63.5 -26.5t57 -26.5t57.5 -12q73 0 105 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 1392,
    d: "M709 1372q145 0 258.5 -51.5t185.5 -144t109.5 -217t37.5 -273.5q0 -196 -81 -359.5t-223 -258.5t-314 -95q-137 0 -249.5 54.5t-186 148t-113 218.5t-39.5 268q0 146 47.5 277t128.5 226.5t195.5 151t243.5 55.5zM295 674q0 -152 49.5 -278t142.5 -200.5t211 -74.5 t210.5 74.5t142 200.5t49.5 278t-49.5 278t-142 200.5t-210.5 74.5t-211 -74.5t-142.5 -200.5t-49.5 -278zM608 1602q0 -47 -30 -80t-72 -33t-72.5 33t-30.5 80q0 46 31 79t72 33t71.5 -33t30.5 -79zM985 1602q0 -47 -30 -80t-72 -33t-72.5 33t-30.5 80q0 46 31 79t72 33 t71.5 -33t30.5 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 878,
    d: "M700 156l-256 254l-249 -250l-107 106l250 252l-260 258l129 74l233 -232l258 261l78 -138l-229 -229l254 -256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 1392,
    d: "M709 1372q49 0 92 -6l43 180h117l-50 -205q189 -62 289 -236.5t100 -418.5q0 -196 -81 -359t-223 -257.5t-314 -94.5q-50 0 -96 9l-41 -170h-111l45 194q-122 44 -209.5 141t-131.5 228.5t-44 284.5q0 146 47.5 277t128.5 226.5t195.5 151t243.5 55.5zM1100 674 q0 167 -61 302.5t-167 201.5l-251 -1047q33 -8 77 -8q118 0 210.5 74t142 199.5t49.5 277.5zM295 674q0 -166 59.5 -300t163.5 -200l248 1045q-31 8 -68 8q-118 0 -211 -74.5t-142.5 -200.5t-49.5 -278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 1488,
    d: "M1100 516v643l-27 189h199v-809q0 -251 -151.5 -408.5t-401.5 -157.5q-99 0 -179.5 27t-130.5 68t-87.5 97t-55.5 104t-28.5 100.5t-12.5 76t-2 39.5v674l-26 189h211v-846q0 -163 99 -271t249 -108t247 114t97 279zM412 1792h225l254 -293l-113 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 1488,
    d: "M1100 516v643l-27 189h199v-809q0 -251 -151.5 -408.5t-401.5 -157.5q-99 0 -179.5 27t-130.5 68t-87.5 97t-55.5 104t-28.5 100.5t-12.5 76t-2 39.5v674l-26 189h211v-846q0 -163 99 -271t249 -108t247 114t97 279zM838 1792h225l-367 -334l-112 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 1488,
    d: "M1100 516v643l-27 189h199v-809q0 -251 -151.5 -408.5t-401.5 -157.5q-99 0 -179.5 27t-130.5 68t-87.5 97t-55.5 104t-28.5 100.5t-12.5 76t-2 39.5v674l-26 189h211v-846q0 -163 99 -271t249 -108t247 114t97 279zM672 1792h127l254 -293l-109 -41l-211 191l-207 -191 l-108 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 1488,
    d: "M1100 516v643l-27 189h199v-809q0 -251 -151.5 -408.5t-401.5 -157.5q-99 0 -179.5 27t-130.5 68t-87.5 97t-55.5 104t-28.5 100.5t-12.5 76t-2 39.5v674l-26 189h211v-846q0 -163 99 -271t249 -108t247 114t97 279zM649 1602q0 -47 -30 -80t-72 -33t-72.5 33t-30.5 80 q0 46 31 79t72 33t71.5 -33t30.5 -79zM1026 1602q0 -47 -30 -80t-72 -33t-72.5 33t-30.5 80q0 46 31 79t72 33t71.5 -33t30.5 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 1042,
    d: "M621 594v-440l20 -154h-205v594l-317 608l-107 146h238l266 -506l29 -82l39 86l268 502h184zM647 1792h225l-366 -334l-113 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 1118,
    d: "M203 1528l211 20v-323h170q69 0 132.5 -15.5t120 -48.5t98.5 -80t66.5 -114.5t24.5 -147.5q0 -178 -147.5 -308t-364.5 -130h-100v-227l20 -154h-205v1298zM414 532h133q114 0 199 85t85 202q0 121 -81.5 187.5t-202.5 66.5h-133v-541z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 1175,
    d: "M526 164l6 45q5 -4 13.5 -10.5t34.5 -23t52.5 -29t62 -23t67.5 -10.5q81 0 130.5 34t49.5 111q0 47 -38 95t-92.5 91.5t-108.5 88.5t-92 101.5t-38 115.5t25.5 113.5t62 98.5t73 88.5t62 100t25.5 115.5q0 58 -41.5 93.5t-128.5 35.5q-120 0 -196 -72t-76 -170v-942 l20 -211h-192v866h-125v140h125v131q0 81 29 150.5t74.5 115.5t102.5 79t112.5 47.5t105.5 14.5q64 0 125.5 -14.5t117 -44t89.5 -83.5t34 -124q0 -57 -24 -115t-58.5 -104t-69.5 -88.5t-59 -84t-24 -75.5q0 -42 37 -91t90 -96t106 -96.5t90 -108t37 -114.5q0 -152 -99 -242 t-263 -90q-65 0 -126.5 19.5t-90.5 39.5l-29 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 1036,
    d: "M231 745l-92 134q5 6 15.5 17t48 38t80.5 47.5t112.5 37.5t145.5 17q63 0 116 -14t97 -44t69 -82t25 -122v-543q0 -55 23 -112.5t46 -88.5l23 -30l-190 -27q-6 9 -16 24.5t-26.5 59.5t-17.5 84q-43 -66 -138 -117t-187 -51q-108 0 -186.5 71.5t-78.5 182.5 q0 169 160.5 274t415.5 105v74q0 115 -42.5 167t-111.5 52q-53 0 -102 -16t-82 -38.5t-58.5 -45t-37.5 -38.5zM440 121q61 0 129.5 41.5t106.5 85.5v227q-27 -1 -39.5 -1.5t-60 -6t-78 -13t-75 -24t-71.5 -38.5t-47 -56.5t-20 -77.5q0 -55 39.5 -96t115.5 -41zM190 1483h226 l254 -293l-113 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 1036,
    d: "M231 745l-92 134q5 6 15.5 17t48 38t80.5 47.5t112.5 37.5t145.5 17q63 0 116 -14t97 -44t69 -82t25 -122v-543q0 -55 23 -112.5t46 -88.5l23 -30l-190 -27q-6 9 -16 24.5t-26.5 59.5t-17.5 84q-43 -66 -138 -117t-187 -51q-108 0 -186.5 71.5t-78.5 182.5 q0 169 160.5 274t415.5 105v74q0 115 -42.5 167t-111.5 52q-53 0 -102 -16t-82 -38.5t-58.5 -45t-37.5 -38.5zM440 121q61 0 129.5 41.5t106.5 85.5v227q-27 -1 -39.5 -1.5t-60 -6t-78 -13t-75 -24t-71.5 -38.5t-47 -56.5t-20 -77.5q0 -55 39.5 -96t115.5 -41zM616 1483h226 l-367 -334l-113 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 1036,
    d: "M231 745l-92 134q5 6 15.5 17t48 38t80.5 47.5t112.5 37.5t145.5 17q63 0 116 -14t97 -44t69 -82t25 -122v-543q0 -55 23 -112.5t46 -88.5l23 -30l-190 -27q-6 9 -16 24.5t-26.5 59.5t-17.5 84q-43 -66 -138 -117t-187 -51q-108 0 -186.5 71.5t-78.5 182.5 q0 169 160.5 274t415.5 105v74q0 115 -42.5 167t-111.5 52q-53 0 -102 -16t-82 -38.5t-58.5 -45t-37.5 -38.5zM440 121q61 0 129.5 41.5t106.5 85.5v227q-27 -1 -39.5 -1.5t-60 -6t-78 -13t-75 -24t-71.5 -38.5t-47 -56.5t-20 -77.5q0 -55 39.5 -96t115.5 -41zM451 1483h127 l253 -293l-108 -41l-211 190l-207 -190l-108 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 1036,
    d: "M231 745l-92 134q5 6 15.5 17t48 38t80.5 47.5t112.5 37.5t145.5 17q63 0 116 -14t97 -44t69 -82t25 -122v-543q0 -55 23 -112.5t46 -88.5l23 -30l-190 -27q-6 9 -16 24.5t-26.5 59.5t-17.5 84q-43 -66 -138 -117t-187 -51q-108 0 -186.5 71.5t-78.5 182.5 q0 169 160.5 274t415.5 105v74q0 115 -42.5 167t-111.5 52q-53 0 -102 -16t-82 -38.5t-58.5 -45t-37.5 -38.5zM440 121q61 0 129.5 41.5t106.5 85.5v227q-27 -1 -39.5 -1.5t-60 -6t-78 -13t-75 -24t-71.5 -38.5t-47 -56.5t-20 -77.5q0 -55 39.5 -96t115.5 -41zM756 1376 l88 -53q-20 -34 -28 -47.5t-28 -37.5t-38 -33.5t-48.5 -18t-68.5 -8.5q-53 0 -100 18t-86 36.5t-70 18.5q-58 0 -103 -67l-88 53q20 34 28 47.5t28 37.5t38 33.5t48.5 18t68.5 8.5q59 0 138.5 -38.5t115.5 -38.5q73 0 105 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 1036,
    d: "M231 745l-92 134q5 6 15.5 17t48 38t80.5 47.5t112.5 37.5t145.5 17q63 0 116 -14t97 -44t69 -82t25 -122v-543q0 -55 23 -112.5t46 -88.5l23 -30l-190 -27q-6 9 -16 24.5t-26.5 59.5t-17.5 84q-43 -66 -138 -117t-187 -51q-108 0 -186.5 71.5t-78.5 182.5 q0 169 160.5 274t415.5 105v74q0 115 -42.5 167t-111.5 52q-53 0 -102 -16t-82 -38.5t-58.5 -45t-37.5 -38.5zM440 121q61 0 129.5 41.5t106.5 85.5v227q-27 -1 -39.5 -1.5t-60 -6t-78 -13t-75 -24t-71.5 -38.5t-47 -56.5t-20 -77.5q0 -55 39.5 -96t115.5 -41zM428 1292 q0 -47 -30 -79.5t-72 -32.5t-72.5 32.5t-30.5 79.5q0 46 31 79.5t72 33.5t71.5 -33.5t30.5 -79.5zM805 1292q0 -47 -30.5 -79.5t-72.5 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5t71.5 33.5t72 -33.5t31 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 1036,
    d: "M231 745l-92 134q5 6 15.5 17t48 38t80.5 47.5t112.5 37.5t145.5 17q63 0 116 -14t97 -44t69 -82t25 -122v-543q0 -55 23 -112.5t46 -88.5l23 -30l-190 -27q-6 9 -16 24.5t-26.5 59.5t-17.5 84q-43 -66 -138 -117t-187 -51q-108 0 -186.5 71.5t-78.5 182.5 q0 169 160.5 274t415.5 105v74q0 115 -42.5 167t-111.5 52q-53 0 -102 -16t-82 -38.5t-58.5 -45t-37.5 -38.5zM440 121q61 0 129.5 41.5t106.5 85.5v227q-27 -1 -39.5 -1.5t-60 -6t-78 -13t-75 -24t-71.5 -38.5t-47 -56.5t-20 -77.5q0 -55 39.5 -96t115.5 -41zM700 1311 q0 -73 -56 -127t-130 -54q-72 0 -127 54t-55 127t54.5 126.5t127.5 53.5q74 0 130 -53.5t56 -126.5zM625 1313q0 43 -33.5 75.5t-75.5 32.5q-44 0 -76 -32t-32 -76t31.5 -80.5t76.5 -36.5q49 0 79 36t30 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 1601,
    d: "M1126 1038q67 0 121.5 -20.5t90 -51.5t62 -76.5t40.5 -87.5t23 -92t11 -81.5t3 -65.5l-50 -55l-565 -19q2 -72 19 -134t50 -113.5t88 -81t126 -29.5q48 0 99.5 14.5t90 35.5t70 42.5t48.5 36.5l17 14l29 -157q-6 -6 -17.5 -15.5t-50.5 -34.5t-82.5 -44t-112 -34.5 t-140.5 -15.5q-117 0 -206 54.5t-142 148.5q-14 -22 -41 -50t-73.5 -65.5t-113.5 -62.5t-139 -25q-92 0 -157.5 39.5t-94.5 98t-29 127.5q0 75 38 140.5t109.5 116.5t182 80.5t246.5 30.5v74q0 115 -41 167t-109 52q-52 0 -101.5 -15.5t-83 -37.5t-60.5 -44.5t-39 -37.5 l-13 -16l-90 131q5 6 15.5 17t48.5 38t81 47.5t113.5 37.5t147.5 17q90 0 162.5 -29.5t111.5 -91.5q120 123 307 123zM444 121q53 0 118 39.5t104 79.5l39 39q-29 91 -29 202q-17 0 -52.5 -3t-97 -16t-113 -34t-90 -62t-38.5 -94q0 -60 40.5 -105.5t118.5 -45.5zM1102 905 q-49 0 -88.5 -24t-66.5 -67t-45 -92t-30 -108l412 15q-3 48 -12.5 92t-29 87.5t-55.5 70t-85 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 983,
    d: "M907 895l-108 -137q-96 137 -230 137q-89 0 -156 -54.5t-99.5 -139t-32.5 -183.5q0 -73 17.5 -140t51 -123.5t91 -90t130.5 -33.5q49 0 98.5 14.5t85.5 34.5t65 40.5t44 35.5l15 14l28 -155q-5 -6 -15.5 -15.5t-47 -34t-77.5 -43t-107.5 -34t-137.5 -15.5 q-97 0 -178.5 44t-133.5 117t-81 164t-29 187q0 110 30.5 208.5t88 176t149 123t205.5 45.5q216 0 334 -143zM471 -119l21 105h59q15 -20 46 -42t60.5 -40.5t58.5 -41t46.5 -54t17.5 -68.5q0 -107 -69 -164t-168 -57q-109 0 -197 63l49 101q21 -21 61.5 -34.5t82.5 -13.5 q116 0 116 76q0 29 -28.5 55t-79 58.5t-76.5 56.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 1007,
    d: "M557 1038q66 0 119.5 -20.5t88.5 -52t61.5 -77.5t40.5 -87.5t23 -93t11.5 -83t3.5 -67.5l-47 -53h-571q2 -72 19.5 -136.5t51 -118.5t89.5 -86t128 -32q49 0 100 14.5t89 34.5t69 40.5t47 35.5l17 14l29 -155q-6 -6 -17.5 -15.5t-50 -34t-82 -43t-111.5 -34t-139 -15.5 q-97 0 -178.5 44t-133.5 117t-81 164t-29 187q0 111 27.5 208.5t81 175.5t142.5 123.5t202 45.5zM532 905q-182 0 -235 -270h422q-3 45 -12.5 87.5t-29.5 86t-57.5 70t-87.5 26.5zM217 1483h225l254 -293l-112 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 1007,
    d: "M557 1038q66 0 119.5 -20.5t88.5 -52t61.5 -77.5t40.5 -87.5t23 -93t11.5 -83t3.5 -67.5l-47 -53h-571q2 -72 19.5 -136.5t51 -118.5t89.5 -86t128 -32q49 0 100 14.5t89 34.5t69 40.5t47 35.5l17 14l29 -155q-6 -6 -17.5 -15.5t-50 -34t-82 -43t-111.5 -34t-139 -15.5 q-97 0 -178.5 44t-133.5 117t-81 164t-29 187q0 111 27.5 208.5t81 175.5t142.5 123.5t202 45.5zM532 905q-182 0 -235 -270h422q-3 45 -12.5 87.5t-29.5 86t-57.5 70t-87.5 26.5zM643 1483h225l-366 -334l-113 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 1007,
    d: "M557 1038q66 0 119.5 -20.5t88.5 -52t61.5 -77.5t40.5 -87.5t23 -93t11.5 -83t3.5 -67.5l-47 -53h-571q2 -72 19.5 -136.5t51 -118.5t89.5 -86t128 -32q49 0 100 14.5t89 34.5t69 40.5t47 35.5l17 14l29 -155q-6 -6 -17.5 -15.5t-50 -34t-82 -43t-111.5 -34t-139 -15.5 q-97 0 -178.5 44t-133.5 117t-81 164t-29 187q0 111 27.5 208.5t81 175.5t142.5 123.5t202 45.5zM532 905q-182 0 -235 -270h422q-3 45 -12.5 87.5t-29.5 86t-57.5 70t-87.5 26.5zM477 1483h127l254 -293l-108 -41l-211 190l-207 -190l-109 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 1007,
    d: "M557 1038q66 0 119.5 -20.5t88.5 -52t61.5 -77.5t40.5 -87.5t23 -93t11.5 -83t3.5 -67.5l-47 -53h-571q2 -72 19.5 -136.5t51 -118.5t89.5 -86t128 -32q49 0 100 14.5t89 34.5t69 40.5t47 35.5l17 14l29 -155q-6 -6 -17.5 -15.5t-50 -34t-82 -43t-111.5 -34t-139 -15.5 q-97 0 -178.5 44t-133.5 117t-81 164t-29 187q0 111 27.5 208.5t81 175.5t142.5 123.5t202 45.5zM532 905q-182 0 -235 -270h422q-3 45 -12.5 87.5t-29.5 86t-57.5 70t-87.5 26.5zM455 1292q0 -47 -30.5 -79.5t-72.5 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5t71.5 33.5 t72 -33.5t31 -79.5zM831 1292q0 -47 -30 -79.5t-72 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5t71.5 33.5t71.5 -33.5t30.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 561,
    d: "M367 1030v-876l20 -154h-192v819l-27 189zM-43 1483h225l254 -293l-112 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 561,
    d: "M367 1030v-876l20 -154h-192v819l-27 189zM383 1483h225l-366 -334l-113 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 561,
    d: "M367 1030v-876l20 -154h-192v819l-27 189zM217 1483h127l254 -293l-109 -41l-210 190l-207 -190l-109 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 561,
    d: "M367 1030v-876l20 -154h-192v819l-27 189zM195 1292q0 -47 -30.5 -79.5t-72.5 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5t71.5 33.5t72 -33.5t31 -79.5zM571 1292q0 -47 -30 -79.5t-72 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5t71.5 33.5t71.5 -33.5t30.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 1122,
    d: "M313 1229l228 98q-57 43 -117.5 66.5t-106.5 23.5l80 129q170 -6 318 -141q44 18 118 50.5t101 43.5l2 -102l-154 -68q116 -140 182 -337t66 -394q0 -129 -29.5 -239.5t-88 -198t-156 -137.5t-224.5 -50q-86 0 -156.5 27.5t-114 68t-76.5 97t-48.5 105t-24.5 101 t-10.5 76t-1.5 39.5q0 147 60 273t162 200t221 74q134 0 256 -94q-74 195 -181 315l-266 -114zM289 506q0 -109 32.5 -199.5t96.5 -146.5t147 -56q123 0 198 127.5t75 397.5q0 92 -17 166q-47 45 -122 78.5t-134 33.5q-83 0 -147 -55.5t-96.5 -146t-32.5 -199.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 1189,
    d: "M1022 0h-193v590q0 157 -29.5 222t-119.5 65q-60 0 -114.5 -15.5t-89 -38t-60.5 -45t-38 -38.5l-11 -15v-571l20 -154h-192v819l-27 189l199 22v-153q65 71 165.5 115t200.5 44q110 0 189 -62.5t79 -178.5v-645zM856 1376l88 -53q-20 -34 -28 -47.5t-28 -37.5t-38 -33.5 t-48.5 -18t-68.5 -8.5q-53 0 -100 18t-86 36.5t-70 18.5q-57 0 -102 -67l-88 53q20 34 28 47.5t28 37.5t38 33.5t48.5 18t68.5 8.5q59 0 138.5 -38.5t115.5 -38.5q72 0 104 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 1132,
    d: "M100 487q0 242 136.5 396.5t365.5 154.5q193 0 311.5 -130.5t118.5 -381.5q0 -149 -58 -273.5t-174 -202t-268 -77.5q-86 0 -156.5 27.5t-114 68t-76.5 97t-48.5 105t-24.5 101t-10.5 76t-1.5 39.5zM289 506q0 -167 75.5 -281t200.5 -114q126 0 202.5 114.5t76.5 280.5 t-76.5 280.5t-202.5 114.5q-125 0 -200.5 -114t-75.5 -281zM242 1483h225l254 -293l-113 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 1132,
    d: "M100 487q0 242 136.5 396.5t365.5 154.5q193 0 311.5 -130.5t118.5 -381.5q0 -149 -58 -273.5t-174 -202t-268 -77.5q-86 0 -156.5 27.5t-114 68t-76.5 97t-48.5 105t-24.5 101t-10.5 76t-1.5 39.5zM289 506q0 -167 75.5 -281t200.5 -114q126 0 202.5 114.5t76.5 280.5 t-76.5 280.5t-202.5 114.5q-125 0 -200.5 -114t-75.5 -281zM668 1483h225l-367 -334l-112 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 1132,
    d: "M100 487q0 242 136.5 396.5t365.5 154.5q193 0 311.5 -130.5t118.5 -381.5q0 -149 -58 -273.5t-174 -202t-268 -77.5q-86 0 -156.5 27.5t-114 68t-76.5 97t-48.5 105t-24.5 101t-10.5 76t-1.5 39.5zM289 506q0 -167 75.5 -281t200.5 -114q126 0 202.5 114.5t76.5 280.5 t-76.5 280.5t-202.5 114.5q-125 0 -200.5 -114t-75.5 -281zM502 1483h127l254 -293l-109 -41l-211 190l-207 -190l-108 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 1132,
    d: "M100 487q0 242 136.5 396.5t365.5 154.5q193 0 311.5 -130.5t118.5 -381.5q0 -149 -58 -273.5t-174 -202t-268 -77.5q-86 0 -156.5 27.5t-114 68t-76.5 97t-48.5 105t-24.5 101t-10.5 76t-1.5 39.5zM289 506q0 -167 75.5 -281t200.5 -114q126 0 202.5 114.5t76.5 280.5 t-76.5 280.5t-202.5 114.5q-125 0 -200.5 -114t-75.5 -281zM807 1376l88 -53q-20 -34 -28 -47.5t-28 -37.5t-38 -33.5t-48.5 -18t-68.5 -8.5q-53 0 -100 18t-86 36.5t-70 18.5q-57 0 -102 -67l-88 53q20 34 28 47.5t28 37.5t38 33.5t48.5 18t68.5 8.5q37 0 75 -12 t63.5 -26.5t57 -26.5t57.5 -12q73 0 105 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 1132,
    d: "M100 487q0 242 136.5 396.5t365.5 154.5q193 0 311.5 -130.5t118.5 -381.5q0 -149 -58 -273.5t-174 -202t-268 -77.5q-86 0 -156.5 27.5t-114 68t-76.5 97t-48.5 105t-24.5 101t-10.5 76t-1.5 39.5zM289 506q0 -167 75.5 -281t200.5 -114q126 0 202.5 114.5t76.5 280.5 t-76.5 280.5t-202.5 114.5q-125 0 -200.5 -114t-75.5 -281zM479 1292q0 -47 -30 -79.5t-72 -32.5t-72.5 32.5t-30.5 79.5q0 46 31 79.5t72 33.5t71.5 -33.5t30.5 -79.5zM856 1292q0 -47 -30 -79.5t-72 -32.5t-72.5 32.5t-30.5 79.5q0 46 31 79.5t72 33.5t71.5 -33.5 t30.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 968,
    d: "M178 584h635l-41 -142h-594v142zM604 834q0 -54 -36 -91.5t-87 -37.5t-87 37.5t-36 91.5q0 51 36 87.5t87 36.5t87 -36.5t36 -87.5zM604 215q0 -54 -36 -91.5t-87 -37.5t-87 37.5t-36 91.5q0 51 36 88t87 37t87 -37t36 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 1132,
    d: "M96 487q0 242 137.5 396.5t368.5 154.5q7 0 22.5 -1t22.5 -1l74 310h117l-80 -332q129 -44 203.5 -168t74.5 -320q0 -149 -58.5 -273.5t-175.5 -202t-270 -77.5q-4 0 -12 1t-12 1l-76 -317h-110l77 334q-60 18 -109.5 53.5t-80 76.5t-53.5 92t-34 92.5t-17.5 85t-7.5 63 t-1 32.5zM293 506q0 -117 37.5 -214t105.5 -147l178 756q-24 6 -49 6q-123 0 -197.5 -116.5t-74.5 -284.5zM838 506q0 105 -31.5 195t-89.5 145l-178 -742h26q123 0 198 117t75 285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 1177,
    d: "M834 152q-60 -76 -169.5 -127.5t-211.5 -51.5q-110 0 -189.5 63t-79.5 179v604l-26 189l198 22v-610q0 -62 3.5 -105t13 -80t26 -58t43 -32.5t64.5 -11.5q60 0 114.5 16t89 38.5t60.5 45t38 38.5l11 16v532l-26 189l198 22v-799q0 -55 23 -112.5t46 -88.5l23 -30 l-190 -27q-7 10 -16.5 26.5t-26 63.5t-16.5 89zM264 1483h225l254 -293l-112 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 1177,
    d: "M834 152q-60 -76 -169.5 -127.5t-211.5 -51.5q-110 0 -189.5 63t-79.5 179v604l-26 189l198 22v-610q0 -62 3.5 -105t13 -80t26 -58t43 -32.5t64.5 -11.5q60 0 114.5 16t89 38.5t60.5 45t38 38.5l11 16v532l-26 189l198 22v-799q0 -55 23 -112.5t46 -88.5l23 -30 l-190 -27q-7 10 -16.5 26.5t-26 63.5t-16.5 89zM690 1483h225l-366 -334l-113 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 1177,
    d: "M834 152q-60 -76 -169.5 -127.5t-211.5 -51.5q-110 0 -189.5 63t-79.5 179v604l-26 189l198 22v-610q0 -62 3.5 -105t13 -80t26 -58t43 -32.5t64.5 -11.5q60 0 114.5 16t89 38.5t60.5 45t38 38.5l11 16v532l-26 189l198 22v-799q0 -55 23 -112.5t46 -88.5l23 -30 l-190 -27q-7 10 -16.5 26.5t-26 63.5t-16.5 89zM524 1483h127l254 -293l-108 -41l-211 190l-207 -190l-109 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 1177,
    d: "M834 152q-60 -76 -169.5 -127.5t-211.5 -51.5q-110 0 -189.5 63t-79.5 179v604l-26 189l198 22v-610q0 -62 3.5 -105t13 -80t26 -58t43 -32.5t64.5 -11.5q60 0 114.5 16t89 38.5t60.5 45t38 38.5l11 16v532l-26 189l198 22v-799q0 -55 23 -112.5t46 -88.5l23 -30 l-190 -27q-7 10 -16.5 26.5t-26 63.5t-16.5 89zM502 1292q0 -47 -30.5 -79.5t-72.5 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5t71.5 33.5t72 -33.5t31 -79.5zM879 1292q0 -47 -30.5 -79.5t-72.5 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5t71.5 33.5t72 -33.5t31 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 972,
    d: "M961 1034l-484 -1206q-63 -157 -161.5 -241.5t-209.5 -84.5q-45 0 -106 23l-29 174q61 -21 105 -21q83 0 153 54.5t111 163.5l43 112l-281 830l-90 170l201 26l240 -682l26 -149l43 149l258 656zM629 1483h225l-367 -334l-112 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 1132,
    d: "M195 -492v1829l-27 189l199 22v-647q142 133 290 133q155 0 262 -136t107 -372q0 -147 -62.5 -273t-178.5 -203t-259 -77q-36 0 -159 13v-324l20 -154h-192zM592 895q-55 0 -114 -36t-111 -103v-635l121 -12q41 -3 71 -3q113 0 195 120t82 282q0 173 -70.5 280 t-173.5 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 972,
    d: "M961 1034l-484 -1206q-63 -157 -161.5 -241.5t-209.5 -84.5q-45 0 -106 23l-29 174q61 -21 105 -21q83 0 153 54.5t111 163.5l43 112l-281 830l-90 170l201 26l240 -682l26 -149l43 149l258 656zM440 1292q0 -47 -30 -79.5t-72 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5 t71.5 33.5t71.5 -33.5t30.5 -79.5zM817 1292q0 -47 -30 -79.5t-72 -32.5t-72.5 32.5t-30.5 79.5q0 46 31 79.5t72 33.5t71.5 -33.5t30.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 561,
    d: "M367 1030v-876l20 -154h-192v819l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1712,
    d: "M1591 1348v-152h-489v-430h428l-41 -152h-387v-462h512l-41 -152h-854q-186 0 -329.5 90.5t-219.5 245.5t-76 346q0 165 47.5 295.5t127.5 209.5t179 120t209 41h934zM293 670q0 -142 51 -264t144 -195.5t206 -73.5h224v1082h-224q-113 0 -206 -77t-144 -202.5 t-51 -269.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1753,
    d: "M104 487q0 242 136.5 396.5t365.5 154.5q215 0 340 -159q120 159 338 159q66 0 119.5 -20.5t88.5 -51.5t61.5 -77t40.5 -87.5t23 -93t11.5 -83.5t3.5 -68l-47 -53h-569q1 -57 12 -110t33.5 -101.5t55 -84.5t80.5 -57.5t106 -21.5q49 0 100 14.5t89 34.5t69 40.5t47 35.5 l16 14l29 -153q-6 -6 -17.5 -15.5t-50 -34t-82 -43t-111.5 -34t-139 -15.5q-104 0 -191.5 49.5t-141.5 131.5q-159 -181 -383 -181q-86 0 -156.5 27.5t-114.5 68t-76.5 97t-48 105t-25 101t-11 76t-1.5 39.5zM293 506q0 -109 32.5 -199.5t96.5 -146.5t147 -56t147.5 56 t97 146.5t32.5 199.5q0 167 -76 284t-201 117q-83 0 -147 -55.5t-96.5 -146t-32.5 -199.5zM1260 905q-181 0 -234 -270h420q-3 45 -12.5 87.5t-29.5 86t-57 70t-87 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 823,
    d: "M346 1483h127l254 -293l-109 -41l-210 190l-207 -190l-109 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 1064,
    d: "M709 1331q0 -73 -56.5 -126.5t-130.5 -53.5q-73 0 -127.5 53.5t-54.5 126.5t54.5 126.5t127.5 53.5q74 0 130.5 -53.5t56.5 -126.5zM633 1333q0 44 -33.5 76.5t-75.5 32.5q-44 0 -76 -32.5t-32 -76.5q0 -43 31.5 -79.5t76.5 -36.5q49 0 79 35.5t30 80.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 778,
    d: "M645 1376l88 -53q-20 -34 -28 -47.5t-28 -37.5t-38 -33.5t-48.5 -18t-68.5 -8.5q-53 0 -100 18t-86 36.5t-70 18.5q-57 0 -102 -67l-88 53q20 34 28 47.5t28 37.5t38 33.5t48.5 18t68.5 8.5q59 0 138.5 -38.5t115.5 -38.5q72 0 104 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023",
    unicode: "\u0401",
    d: "M229 0v1159l-26 189h700v-152h-489v-430h428l-41 -152h-387v-462h512l-41 -152h-656zM475 1602q0 -47 -30 -80t-72 -33t-72.5 33t-30.5 80q0 46 31 79t72 33t71.5 -33t30.5 -79zM852 1602q0 -47 -30 -80t-72 -33t-72.5 33t-30.5 80q0 46 31 79t72 33t71.5 -33t30.5 -79z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10051",
    unicode: "\u0402",
    horizAdvX: 1314,
    d: "M1233 442v-155q0 -180 -58.5 -264t-177.5 -84q-20 0 -46.5 5.5t-42.5 11.5l-17 5l-27 166q51 -21 90 -21q43 0 69 43.5t26 137.5v155q0 140 -69.5 205.5t-205.5 65.5q-76 0 -157 -19t-123 -38l-43 -19v-449l26 -188h-211v1192h-225v156h717v-156h-307v-393q7 3 20 8 t54.5 17.5t84.5 22t107 17.5t125 8q179 0 285 -107t106 -323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10052",
    unicode: "\u0403",
    horizAdvX: 921,
    d: "M229 1159l-26 189h700v-156h-489v-1038l20 -154h-205v1159zM713 1780h225l-367 -334l-112 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10053",
    unicode: "\u0404",
    horizAdvX: 1263,
    d: "M858 778v-164h-567q13 -230 140.5 -356.5t318.5 -126.5q52 0 112 17.5t108.5 43t89.5 51t64 43.5l23 17l45 -151q-8 -7 -23 -19t-63.5 -43t-101 -54.5t-131 -43t-156.5 -19.5q-133 0 -245 41t-197.5 122t-134 211t-48.5 298q0 338 175 532.5t476 194.5q248 0 431 -168 l-95 -139q-150 156 -344 156q-192 0 -304 -120.5t-136 -322.5h563z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10054",
    unicode: "\u0405",
    horizAdvX: 983,
    d: "M111 125l20 176q6 -7 17.5 -19.5t48 -43.5t75 -54.5t96.5 -43t115 -19.5q92 0 155.5 60t63.5 163q0 54 -32.5 101t-84 82t-114.5 69t-125.5 71.5t-114 80.5t-84 104.5t-32.5 134.5q0 161 112 273t283 112q188 0 338 -96l-53 -150q-3 8 -40.5 30.5t-109 46.5t-141.5 24 q-78 0 -137.5 -50.5t-59.5 -134.5q0 -60 32 -108.5t83 -84t112.5 -68.5t123 -71t112.5 -82t83 -110t32 -147q0 -176 -111.5 -287t-296.5 -111q-68 0 -130.5 15.5t-103.5 38t-72.5 45t-45.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0406",
    unicode: "\u0406",
    horizAdvX: 638,
    d: "M414 1348v-1194l20 -154h-205v1159l-26 189h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10056",
    unicode: "\u0407",
    horizAdvX: 638,
    d: "M414 1348v-1194l20 -154h-205v1159l-26 189h211zM240 1602q0 -47 -30.5 -80t-72.5 -33t-72 33t-30 80q0 46 30.5 79t71.5 33t72 -33t31 -79zM616 1602q0 -47 -30 -80t-72 -33t-72 33t-30 80q0 46 30.5 79t71.5 33t71.5 -33t30.5 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10057",
    unicode: "\u0408",
    horizAdvX: 608,
    d: "M401 1348v-1270q0 -97 -23.5 -182.5t-71 -154.5t-126 -109t-180.5 -40q-44 0 -111 13l11 180q59 -27 100 -27q97 0 157 93.5t60 226.5v1081l-27 189h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10058",
    unicode: "\u0409",
    horizAdvX: 1812,
    d: "M510 1184l-10 -242q-5 -130 -9 -202.5t-12.5 -180.5t-19.5 -168.5t-28.5 -138.5t-42 -120t-58 -83.5t-79 -58.5t-101.5 -17q-47 0 -101 15l-18 170q41 -13 82 -13q23 0 42.5 7t36 23.5t29.5 36.5t23.5 55.5t18.5 69t15.5 87.5t12 102.5t9.5 122t8.5 137t8.5 156.5l11 217 l-27 189h780v-529h146q109 0 195.5 -22.5t143.5 -60.5t95 -91t54 -111t16 -124q0 -83 -27 -154t-84 -129.5t-157.5 -92.5t-235.5 -34h-330v1184h-387zM1081 672v-525h170q79 0 136.5 21.5t88.5 60t45.5 83t14.5 98.5q0 143 -77 202.5t-240 59.5h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10059",
    unicode: "\u040A",
    horizAdvX: 1835,
    d: "M1104 1348v-557h145q108 0 195 -23.5t144 -61.5t95 -90.5t54 -107t16 -113.5t-16 -114t-54 -107t-95 -90t-144 -61t-195 -23h-329v627h-506v-473l20 -154h-205v1159l-26 189h211v-557h506v368l-27 189h211zM1104 643v-496h170q78 0 136 22t89 59.5t45.5 79t14.5 87.5 q0 131 -78.5 189.5t-239.5 58.5h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10060",
    unicode: "\u040B",
    horizAdvX: 1331,
    d: "M31 1192v156h717v-156h-308v-393q7 3 20 8t54.5 17.5t84.5 22t107 17.5t125 8q179 0 285.5 -107.5t106.5 -322.5v-254l26 -188h-211v442q0 140 -69 205.5t-205 65.5q-76 0 -157 -19t-124 -38l-43 -19v-449l27 -188h-211v1192h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10061",
    unicode: "\u040C",
    horizAdvX: 1202,
    d: "M414 772h145l193 361q127 239 299 239q50 0 82 -12l18 -170q-24 6 -68 6q-83 0 -165 -147l-197 -353l450 -696h-233l-379 608h-145v-454l20 -154h-205v1159l-26 189h211v-576zM797 1747h225l-367 -334l-112 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10062",
    unicode: "\u040E",
    horizAdvX: 1259,
    d: "M1239 1348l-455 -1049q-72 -164 -167.5 -245t-237.5 -81q-46 0 -107 23l-28 174q58 -20 104 -20q167 0 238 139l-416 833l-150 226h252l363 -727l49 -140l47 140l313 727h195zM676 1528q37 0 72 20.5t58.5 49.5t42 58t27.5 50l9 20l112 -40q-2 -6 -5 -16.5t-16 -41 t-29 -58t-43 -61.5t-58.5 -58.5t-76 -41t-93.5 -16.5t-93.5 16t-76 42t-58.5 57t-43.5 62.5t-28.5 57.5t-17 42l-5 16l113 40q3 -8 9 -21.5t26.5 -47.5t43 -60t58 -47.5t72.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10145",
    unicode: "\u040F",
    horizAdvX: 1542,
    d: "M1319 1194v-1194h-453v-328h-184v328h-479l26 188v1160h205l-20 -154v-1030h721v1184h204z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017",
    unicode: "\u0410",
    horizAdvX: 1169,
    d: "M-4 0l520 1348l125 26l418 -1149l102 -225h-223l-129 352h-502l-133 -352h-178zM543 977l-181 -469h396l-170 471l-21 80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10018",
    unicode: "\u0411",
    horizAdvX: 1134,
    d: "M414 672v-525h149q79 0 136.5 21.5t88.5 60t45.5 83t14.5 98.5q0 143 -77.5 202.5t-240.5 59.5h-116zM414 1196v-377h125q135 0 235 -33.5t157 -92.5t84 -129.5t27 -153.5q0 -66 -16 -124t-54 -111t-94.5 -91.5t-143 -61t-195.5 -22.5h-310v1159l-26 189h731v-152h-520z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10019",
    unicode: "\u0412",
    horizAdvX: 1144,
    d: "M414 1204v-399h147q22 0 45 -1.5t40.5 -3.5t32 -4t23 -3.5t9.5 -1.5q77 103 77 206q0 108 -69 159.5t-217 51.5q-26 0 -88 -4zM203 1348l323 10q196 6 317.5 -78.5t121.5 -241.5q0 -126 -154 -280q54 -25 93 -52t72 -67t49.5 -95t16.5 -126q0 -86 -27 -158.5t-84 -132 t-157 -93.5t-235 -34h-310v1159zM414 653v-506h149q79 0 136.5 21.5t88.5 58.5t45.5 79.5t14.5 92.5q0 136 -78.5 195t-239.5 59h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10020",
    unicode: "\u0413",
    horizAdvX: 921,
    d: "M229 1159l-26 189h700v-156h-489v-1038l20 -154h-205v1159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10021",
    unicode: "\u0414",
    horizAdvX: 1353,
    d: "M20 -328l5 492h129q93 172 124 369.5t31 490.5l2 135l-26 189h829v-1184h154l4 -492h-187l-2 328h-874l-2 -328h-187zM494 1024q0 -287 -28.5 -487t-107.5 -373h572v1020h-436v-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022",
    unicode: "\u0415",
    d: "M229 0v1159l-26 189h700v-152h-489v-430h428l-41 -152h-387v-462h512l-41 -152h-656z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10024",
    unicode: "\u0416",
    horizAdvX: 1679,
    d: "M748 772v387l-27 189h211v-576h121l176 361q116 239 299 239q50 0 82 -12l18 -170q-24 6 -67 6q-93 0 -166 -147l-176 -353l430 -696h-228l-366 608h-123v-454l20 -154h-204v608h-123l-367 -608h-227l430 696l-176 353q-73 147 -166 147q-44 0 -68 -6l19 170q32 12 82 12 q183 0 299 -239l176 -361h121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10025",
    unicode: "\u0417",
    horizAdvX: 1044,
    d: "M313 788h156q89 0 160 -18q90 97 90 242q0 96 -64 152.5t-174 56.5q-157 0 -295 -144l-94 140q169 155 391 155q87 0 160.5 -21t130.5 -63.5t89 -113t32 -162.5q0 -75 -43 -148.5t-111 -134.5q101 -55 151 -147t50 -201q0 -64 -16 -122t-52 -110.5t-87.5 -91.5 t-128 -61.5t-169.5 -22.5q-67 0 -133.5 16.5t-113.5 40t-84.5 47t-56.5 39.5l-19 17l45 152q6 -6 17.5 -16.5t49.5 -37t77.5 -47t99 -37t118.5 -16.5q54 0 99.5 17t74 43.5t48.5 60.5t28.5 66.5t8.5 62.5q0 134 -73.5 194t-213.5 60h-148v153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026",
    unicode: "\u0418",
    horizAdvX: 1542,
    d: "M1135 1071l-56 -104l-671 -967h-179v1159l-26 189h211v-1072l55 105l672 967h178v-1194l20 -154h-204v1071z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10027",
    unicode: "\u0419",
    horizAdvX: 1542,
    d: "M774 1528q37 0 72 20.5t58.5 49.5t42 58t27.5 50l9 20l113 -40q-2 -6 -5 -16.5t-16.5 -41t-29 -58t-43 -61.5t-58.5 -58.5t-76 -41t-94 -16.5t-93.5 16t-76 42t-58 57t-43.5 62.5t-28.5 57.5t-16.5 42l-5 16l112 40q3 -8 9 -21.5t26.5 -47.5t43 -60t58 -47.5t72.5 -21.5z M1135 1071l-56 -104l-671 -967h-179v1159l-26 189h211v-1072l55 105l672 967h178v-1194l20 -154h-204v1071z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10028",
    unicode: "\u041A",
    horizAdvX: 1202,
    d: "M414 772h145l193 361q127 239 299 239q50 0 82 -12l18 -170q-24 6 -68 6q-83 0 -165 -147l-197 -353l450 -696h-233l-379 608h-145v-454l20 -154h-205v1159l-26 189h211v-576z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10029",
    unicode: "\u041B",
    horizAdvX: 1368,
    d: "M510 1184l-10 -242q-5 -130 -9 -202.5t-12.5 -180.5t-19.5 -168.5t-28.5 -138.5t-42 -120t-58 -83.5t-79 -58.5t-101.5 -17q-47 0 -101 15l-18 170q41 -13 82 -13q23 0 42.5 7t36 23.5t29.5 36.5t23.5 55.5t18.5 69t15.5 87.5t12 102.5t9.5 122t8.5 137t8.5 156.5l11 217 l-27 189h844v-1194l20 -154h-204v1184h-451z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10030",
    unicode: "\u041C",
    horizAdvX: 1830,
    d: "M940 152l-475 653l-68 135v-786l21 -154h-189v1159l-26 189h135l610 -871l553 871h115v-1194l20 -154h-204v948l-72 -143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10031",
    unicode: "\u041D",
    horizAdvX: 1542,
    d: "M1319 1348v-1194l20 -154h-204v614h-721v-460l20 -154h-205v1159l-26 189h211v-570h721v381l-27 189h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032",
    unicode: "\u041E",
    horizAdvX: 1392,
    d: "M709 1372q145 0 258.5 -51.5t185.5 -144t109.5 -217t37.5 -273.5q0 -196 -81 -359.5t-223 -258.5t-314 -95q-137 0 -249.5 54.5t-186 148t-113 218.5t-39.5 268q0 146 47.5 277t128.5 226.5t195.5 151t243.5 55.5zM295 674q0 -152 49.5 -278t142.5 -200.5t211 -74.5 t210.5 74.5t142 200.5t49.5 278t-49.5 278t-142 200.5t-210.5 74.5t-211 -74.5t-142.5 -200.5t-49.5 -278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10033",
    unicode: "\u041F",
    horizAdvX: 1542,
    d: "M1319 1348v-1194l20 -154h-204v1184h-721v-1030l20 -154h-205v1159l-26 189h1116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10034",
    unicode: "\u0420",
    horizAdvX: 1118,
    d: "M203 1348h381q69 0 132.5 -15.5t120 -48.5t98.5 -80t66.5 -114.5t24.5 -147.5q0 -178 -147.5 -308t-364.5 -130h-100v-350l20 -154h-205v1159zM414 655h133q118 0 201 79.5t83 207.5q0 121 -81.5 187.5t-202.5 66.5h-133v-541z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10035",
    unicode: "\u0421",
    horizAdvX: 1263,
    d: "M1174 1204l-95 -139q-150 156 -344 156q-128 0 -231.5 -79.5t-159 -206t-55.5 -269.5q0 -120 40 -222.5t105 -169.5t147.5 -105t168.5 -38q52 0 112 17.5t108.5 43t89.5 51t64 43.5l23 17l45 -151q-8 -7 -23 -19t-63.5 -43t-101 -54.5t-131 -43t-156.5 -19.5 q-121 0 -232 44.5t-199 126.5t-141 212t-53 289q0 154 51.5 290t139 231.5t207.5 150.5t253 55q248 0 431 -168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10036",
    unicode: "\u0422",
    horizAdvX: 1077,
    d: "M10 1192v156h1057v-156h-442v-1038l20 -154h-205v1192h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037",
    unicode: "\u0423",
    horizAdvX: 1259,
    d: "M1239 1348l-455 -1049q-72 -164 -167.5 -245t-237.5 -81q-46 0 -107 23l-28 174q58 -20 104 -20q167 0 238 139l-416 833l-150 226h252l363 -727l49 -140l47 140l313 727h195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10038",
    unicode: "\u0424",
    horizAdvX: 1429,
    d: "M61 657q0 154 75.5 273.5t202.5 183.5t284 66l-27 188h211v-188q157 -2 284 -66t202 -183.5t75 -273.5t-75 -273.5t-202 -184t-284 -66.5l20 -153h-204v153q-157 2 -284 66.5t-202.5 184t-75.5 273.5zM262 657q0 -172 98.5 -277.5t262.5 -105.5v764q-165 0 -263 -105 t-98 -276zM1167 657q0 171 -97.5 276t-262.5 105v-764q164 0 262 105.5t98 277.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10039",
    unicode: "\u0425",
    horizAdvX: 1017,
    d: "M18 0l400 684l-289 518l-106 146h239l240 -428l30 -64l27 64l244 428h192l-383 -648l394 -700h-220l-254 461l-30 67l-33 -71l-256 -457h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10040",
    unicode: "\u0426",
    horizAdvX: 1490,
    d: "M223 0v1194l-20 154h205v-1184h659v1030l-20 154h204v-1184h154l4 -492h-186l-2 328h-998z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10041",
    unicode: "\u0427",
    horizAdvX: 1339,
    d: "M541 475q-179 0 -285 107t-106 323v254l-27 189h211v-443q0 -140 69 -205t205 -65q76 0 157 19t124 38l43 19v448l-27 189h211v-1194l21 -154h-205v549q-19 -8 -54 -20.5t-137.5 -33t-199.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10042",
    unicode: "\u0428",
    horizAdvX: 2007,
    d: "M922 164v1030l-21 154h205v-1184h514v1030l-21 154h205v-1348h-1581v1194l-20 154h205v-1184h514z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10043",
    unicode: "\u0429",
    horizAdvX: 2043,
    d: "M922 164v1030l-21 154h205v-1184h514v1030l-21 154h205v-1184h154l4 -492h-186l-2 328h-1551v1194l-20 154h205v-1184h514z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10044",
    unicode: "\u042A",
    horizAdvX: 1206,
    d: "M496 672v-525h149q79 0 136.5 21.5t88.5 60t45.5 83t14.5 98.5q0 143 -77.5 202.5t-240.5 59.5h-116zM0 1348h496v-529h125q135 0 235 -33.5t157 -92.5t84 -129.5t27 -153.5q0 -66 -16 -124t-54 -111t-94.5 -91.5t-143 -61t-195.5 -22.5h-310v1192h-311v156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045",
    unicode: "\u042B",
    horizAdvX: 1656,
    d: "M414 672v-525h149q79 0 136.5 21.5t88.5 60t45.5 83t14.5 98.5q0 143 -77.5 202.5t-240.5 59.5h-116zM414 1348v-529h125q135 0 235 -33.5t157 -92.5t84 -129.5t27 -153.5q0 -66 -16 -124t-54 -111t-94.5 -91.5t-143 -61t-195.5 -22.5h-310v1159l-26 189h211zM1434 1348 v-1194l20 -154h-205v1159l-26 189h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10046",
    unicode: "\u042C",
    horizAdvX: 1124,
    d: "M414 672v-525h149q79 0 136.5 21.5t88.5 60t45.5 83t14.5 98.5q0 143 -77.5 202.5t-240.5 59.5h-116zM414 1348v-529h125q135 0 235 -33.5t157 -92.5t84 -129.5t27 -153.5q0 -66 -16 -124t-54 -111t-94.5 -91.5t-143 -61t-195.5 -22.5h-310v1159l-26 189h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047",
    unicode: "\u042D",
    horizAdvX: 1263,
    d: "M406 614v164h563q-24 202 -136.5 322.5t-304.5 120.5q-194 0 -344 -156l-94 139q183 168 430 168q301 0 476 -194.5t175 -532.5q0 -135 -31.5 -246t-88 -189t-135 -132t-171 -79.5t-198.5 -25.5q-78 0 -155.5 18.5t-133 44.5t-99 52.5t-65.5 45.5l-22 18l45 151 q9 -7 24 -18.5t61.5 -41t92 -52.5t106.5 -41.5t113 -18.5q191 0 318.5 126.5t140.5 356.5h-567z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048",
    unicode: "\u042E",
    horizAdvX: 1826,
    d: "M1174 1372q134 0 241 -52t176.5 -144t106.5 -217t37 -273q0 -146 -47.5 -278.5t-126.5 -227.5t-187.5 -151t-226.5 -56q-161 0 -286 86t-194 230.5t-77 324.5h-176v-460l20 -154h-205v1159l-26 189h211v-570h184q22 167 103.5 303t206 213.5t266.5 77.5zM791 674 q0 -151 48.5 -277.5t134.5 -201t189 -74.5t188.5 74.5t134 201t48.5 277.5t-48.5 277.5t-134 201t-188.5 74.5t-189 -74.5t-134.5 -201t-48.5 -277.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049",
    unicode: "\u042F",
    horizAdvX: 1234,
    d: "M821 676v524h-149q-79 0 -136.5 -21.5t-88.5 -59.5t-45.5 -82.5t-14.5 -98.5q0 -143 77.5 -202.5t240.5 -59.5h116zM193 938q0 66 16 124t54 111t94.5 91.5t143 61t195.5 22.5h310v-1160l26 -188h-211v528h-176l-330 -528h-233l367 567q-131 48 -193.5 147t-62.5 224z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065",
    unicode: "\u0430",
    horizAdvX: 1036,
    d: "M231 745l-92 134q5 6 15.5 17t48 38t80.5 47.5t112.5 37.5t145.5 17q63 0 116 -14t97 -44t69 -82t25 -122v-543q0 -55 23 -112.5t46 -88.5l23 -30l-190 -27q-6 9 -16 24.5t-26.5 59.5t-17.5 84q-43 -66 -138 -117t-187 -51q-108 0 -186.5 71.5t-78.5 182.5 q0 169 160.5 274t415.5 105v74q0 115 -42.5 167t-111.5 52q-53 0 -102 -16t-82 -38.5t-58.5 -45t-37.5 -38.5zM440 121q61 0 129.5 41.5t106.5 85.5v227q-27 -1 -39.5 -1.5t-60 -6t-78 -13t-75 -24t-71.5 -38.5t-47 -56.5t-20 -77.5q0 -55 39.5 -96t115.5 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10066",
    unicode: "\u0431",
    horizAdvX: 1112,
    d: "M557 791q-125 0 -201.5 -97.5t-76.5 -249.5q0 -142 75.5 -237.5t202.5 -95.5q117 0 191.5 95t74.5 245q0 145 -74 242.5t-192 97.5zM961 1239q-148 -20 -250.5 -40.5t-180 -50.5t-123.5 -62.5t-76.5 -84.5t-44.5 -108t-22 -141q118 176 330 176q179 0 298.5 -126 t119.5 -331q0 -222 -132 -360t-356 -138q-184 0 -304 127.5t-120 339.5v72q0 130 7.5 229t27 183.5t47 145t74.5 111t102.5 83.5t138 60.5t173.5 45.5t215 35q72 10 102 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10067",
    unicode: "\u0432",
    horizAdvX: 1032,
    d: "M360 885v-283h191q76 0 106 -6q74 74 74 158q0 73 -53 105.5t-172 29.5zM360 473v-338h193q121 0 172 46.5t51 119.5q0 89 -61 130.5t-187 41.5h-168zM168 1008l356 12q171 6 268 -59t97 -185q0 -47 -21 -88.5t-44.5 -65.5t-61.5 -55q85 -33 136.5 -96.5t51.5 -157.5 q0 -68 -21 -122.5t-67.5 -98.5t-129.5 -68t-197 -24h-347v858z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10068",
    unicode: "\u0433",
    horizAdvX: 813,
    d: "M168 1008h604v-144h-412v-710l21 -154h-193v854z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10069",
    unicode: "\u0434",
    horizAdvX: 1150,
    d: "M272 778l2 80l-20 150h698v-869h133v-436h-172v297h-706v-297h-172v436h106q119 195 131 639zM332 139h448v729h-334v-90q0 -176 -29 -351.5t-85 -287.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070",
    unicode: "\u0435",
    horizAdvX: 1007,
    d: "M557 1038q66 0 119.5 -20.5t88.5 -52t61.5 -77.5t40.5 -87.5t23 -93t11.5 -83t3.5 -67.5l-47 -53h-571q2 -72 19.5 -136.5t51 -118.5t89.5 -86t128 -32q49 0 100 14.5t89 34.5t69 40.5t47 35.5l17 14l29 -155q-6 -6 -17.5 -15.5t-50 -34t-82 -43t-111.5 -34t-139 -15.5 q-97 0 -178.5 44t-133.5 117t-81 164t-29 187q0 111 27.5 208.5t81 175.5t142.5 123.5t202 45.5zM532 905q-182 0 -235 -270h422q-3 45 -12.5 87.5t-29.5 86t-57.5 70t-87.5 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10072",
    unicode: "\u0436",
    horizAdvX: 1470,
    d: "M649 575v279l-20 154h192v-433h92l123 246q57 113 130.5 158t162.5 45q42 0 74 -12l18 -152q-19 8 -59 8q-110 0 -174 -123l-119 -231l377 -514h-221l-314 436h-90v-282l21 -154h-193v436h-90l-313 -436h-221l376 514l-118 231q-64 123 -174 123q-41 0 -60 -8l19 152 q32 12 73 12q89 0 162.5 -45t130.5 -158l123 -246h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10073",
    unicode: "\u0437",
    horizAdvX: 888,
    d: "M410 899q-71 0 -136.5 -33t-113.5 -88l-107 125q135 135 357 135q166 0 258 -67.5t92 -192.5q0 -126 -131 -221q168 -74 168 -256q0 -148 -98.5 -238t-299.5 -90q-58 0 -115 13.5t-97.5 32.5t-72 37.5t-47.5 31.5l-16 14l29 156q6 -5 16.5 -14t44.5 -31.5t69 -40 t87 -31.5t102 -14q116 0 170 51.5t54 120.5q0 78 -56.5 118t-160.5 40h-138v141h160q56 0 86 -6q88 72 88 162q0 65 -51.5 105t-140.5 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074",
    unicode: "\u0438",
    horizAdvX: 1198,
    d: "M367 1030v-764l51 101l430 641h162v-858l20 -150h-192v741l-52 -100l-430 -641h-161v819l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10075",
    unicode: "\u0439",
    horizAdvX: 1191,
    d: "M596 1229q37 0 68.5 17t50 41.5t32 49t18.5 41.5l5 17l111 -37q-2 -10 -7.5 -27.5t-28 -62t-51.5 -78.5t-82 -62t-116 -28t-115.5 26.5t-82.5 64.5t-51 76t-29 65l-7 26l111 37q2 -7 5.5 -18t18 -39.5t32.5 -50.5t49.5 -40t68.5 -18zM360 1030v-764l52 101l430 641h162 v-858l20 -150h-193v741l-51 -100l-430 -641h-162v819l-26 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10076",
    unicode: "\u043A",
    horizAdvX: 1056,
    d: "M367 1030v-455h110l146 246q66 111 136.5 157t155.5 46q42 0 74 -12l19 -152q-19 8 -60 8q-102 0 -174 -123l-139 -231l397 -514h-223l-334 436h-108v-282l20 -154h-192v819l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10077",
    unicode: "\u043B",
    horizAdvX: 1159,
    d: "M266 690l8 168l-20 150h717v-858l20 -150h-192v868h-353l-6 -168q-2 -63 -4.5 -107.5t-8 -109t-12.5 -111t-19 -103t-27.5 -96.5t-38.5 -80t-51 -64.5t-65 -40t-81 -15.5q-43 0 -94 15l-19 159q35 -12 76 -12q32 0 57 18.5t42.5 57.5t29.5 84.5t20 114t12.5 131 t8.5 149.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10078",
    unicode: "\u043C",
    horizAdvX: 1447,
    d: "M1038 561l-307 -461l-332 453l-49 86v-485l21 -154h-183v858l-20 150h123l448 -611l408 611h113v-858l20 -150h-193v653z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10079",
    unicode: "\u043D",
    horizAdvX: 1198,
    d: "M1010 1030v-880l20 -150h-192v444h-471v-290l20 -154h-192v819l-27 189l199 22v-446h471v235l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080",
    unicode: "\u043E",
    horizAdvX: 1132,
    d: "M100 487q0 242 136.5 396.5t365.5 154.5q193 0 311.5 -130.5t118.5 -381.5q0 -149 -58 -273.5t-174 -202t-268 -77.5q-86 0 -156.5 27.5t-114 68t-76.5 97t-48.5 105t-24.5 101t-10.5 76t-1.5 39.5zM289 506q0 -167 75.5 -281t200.5 -114q126 0 202.5 114.5t76.5 280.5 t-76.5 280.5t-202.5 114.5q-125 0 -200.5 -114t-75.5 -281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10081",
    unicode: "\u043F",
    horizAdvX: 1191,
    d: "M168 1008h836v-858l20 -150h-193v868h-471v-714l21 -154h-193v858z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10082",
    unicode: "\u0440",
    horizAdvX: 1132,
    d: "M195 -492v1311l-27 189l199 22v-121q4 5 11.5 13.5t35 30t58 38t81 30t104.5 13.5q155 0 262 -136t107 -372q0 -147 -62.5 -273t-178.5 -203t-259 -77q-36 0 -159 13v-324l20 -154h-192zM367 121l121 -12q41 -3 71 -3q113 0 195 120t82 282q0 171 -67.5 276t-170.5 105 q-38 0 -76 -13.5t-65 -33.5t-48 -39.5t-31 -32.5l-11 -14v-635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10083",
    unicode: "\u0441",
    horizAdvX: 983,
    d: "M907 895l-108 -137q-96 137 -230 137q-89 0 -156 -54.5t-99.5 -139t-32.5 -183.5q0 -73 17.5 -140t51 -123.5t91 -90t130.5 -33.5q49 0 98.5 14.5t85.5 34.5t65 40.5t44 35.5l15 14l28 -155q-5 -6 -15.5 -15.5t-47 -34t-77.5 -43t-107.5 -34t-137.5 -15.5 q-97 0 -178.5 44t-133.5 117t-81 164t-29 187q0 110 30.5 208.5t88 176t149 123t205.5 45.5q216 0 334 -143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10084",
    unicode: "\u0442",
    horizAdvX: 872,
    d: "M20 1008h832v-144h-330v-710l21 -154h-193v864h-330v144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085",
    unicode: "\u0443",
    horizAdvX: 972,
    d: "M961 1034l-484 -1206q-63 -157 -161.5 -241.5t-209.5 -84.5q-45 0 -106 23l-29 174q61 -21 105 -21q83 0 153 54.5t111 163.5l43 112l-281 830l-90 170l201 26l240 -682l26 -149l43 149l258 656z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10086",
    unicode: "\u0444",
    horizAdvX: 1425,
    d: "M799 901v-790q68 0 124 20.5t95 56.5t66 86t40 108.5t13 123.5q0 183 -85 289t-253 106zM627 1028v307l-27 189l199 22v-518q254 0 390 -128t136 -374q0 -108 -34.5 -205t-99.5 -172.5t-166.5 -120t-225.5 -44.5v-322l20 -154h-192v476q-254 0 -390.5 127.5t-136.5 373.5 q0 108 35 205t99.5 173t166.5 120.5t226 44.5zM627 111v790q-68 0 -124 -20.5t-95 -56.5t-66 -86t-40 -108.5t-13 -123.5q0 -183 85 -289t253 -106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10087",
    unicode: "\u0445",
    horizAdvX: 913,
    d: "M911 1034l-348 -485l350 -549h-213l-215 350l-30 60l-29 -60l-240 -350h-186l373 530l-211 332l-127 146l219 26l199 -313l20 -51l31 51l201 287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10088",
    unicode: "\u0446",
    horizAdvX: 1183,
    d: "M367 1030v-891h446v680l-27 189l199 22v-891h133v-436h-172v297h-751v819l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10089",
    unicode: "\u0447",
    horizAdvX: 1134,
    d: "M946 1030v-880l21 -150h-193v383q-14 -6 -40.5 -15t-105.5 -24.5t-155 -15.5q-323 0 -323 358v133l-27 189l199 22v-344q0 -108 52 -154.5t148 -46.5q59 0 122 13t96 26l34 13v282l-26 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10090",
    unicode: "\u0448",
    horizAdvX: 1615,
    d: "M1448 1030v-1030h-1253v819l-27 189l199 22v-891h368v680l-26 189l198 22v-891h369v680l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10091",
    unicode: "\u0449",
    horizAdvX: 1646,
    d: "M367 1030v-891h368v680l-26 189l198 22v-891h369v680l-27 189l199 22v-891h133v-436h-172v297h-1214v819l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10092",
    unicode: "\u044A",
    horizAdvX: 1062,
    d: "M604 504h-162v-369h162q122 0 172.5 49t50.5 135t-50.5 135.5t-172.5 49.5zM0 1008h442v-369h144q415 0 415 -320q0 -319 -415 -319h-316v864h-270v144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093",
    unicode: "\u044B",
    horizAdvX: 1452,
    d: "M528 504h-161v-369h161q122 0 173 49t51 135q0 185 -224 185zM1264 1030v-876l20 -154h-192v819l-27 189zM367 1030v-391h143q416 0 416 -320q0 -319 -416 -319h-315v819l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10094",
    unicode: "\u044C",
    horizAdvX: 987,
    d: "M528 504h-161v-369h161q122 0 173 49t51 135q0 185 -224 185zM367 1030v-391h143q416 0 416 -320q0 -319 -416 -319h-315v819l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095",
    unicode: "\u044D",
    horizAdvX: 983,
    d: "M326 442v144h372q-14 141 -85.5 225t-198.5 84q-134 0 -230 -137l-108 137q118 143 334 143q118 0 210 -42.5t148.5 -118.5t85.5 -175t29 -217q0 -83 -17 -158.5t-51.5 -140t-84 -112t-118.5 -74.5t-151 -27q-71 0 -137 14.5t-109 35.5t-76 42t-48 35l-15 15l28 155 q5 -6 15.5 -15t43 -33t66.5 -42.5t84 -33.5t99 -15q133 0 202 84.5t84 226.5h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096",
    unicode: "\u044E",
    horizAdvX: 1509,
    d: "M934 -27q-83 0 -153 28.5t-118 74.5t-83 107.5t-53 126t-23 130.5h-144v-286l21 -154h-193v858l-20 150h192v-428h148q26 206 161 332t335 126q88 0 161 -31t128 -92t85.5 -160.5t30.5 -228.5q0 -152 -55 -276.5t-164.5 -200.5t-255.5 -76zM690 506q0 -164 78.5 -279.5 t198.5 -115.5q117 0 185.5 113.5t68.5 281.5t-68.5 281.5t-185.5 113.5q-120 0 -198.5 -115.5t-78.5 -279.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097",
    unicode: "\u044F",
    horizAdvX: 1038,
    d: "M537 504h141v368h-141q-122 0 -173 -49t-51 -135t51 -135t173 -49zM678 369h-135l-262 -369h-220l283 397q-205 66 -205 291q0 320 416 320h295v-858l20 -150h-192v369z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071",
    unicode: "\u0451",
    horizAdvX: 1007,
    d: "M557 1038q66 0 119.5 -20.5t88.5 -52t61.5 -77.5t40.5 -87.5t23 -93t11.5 -83t3.5 -67.5l-47 -53h-571q2 -72 19.5 -136.5t51 -118.5t89.5 -86t128 -32q49 0 100 14.5t89 34.5t69 40.5t47 35.5l17 14l29 -155q-6 -6 -17.5 -15.5t-50 -34t-82 -43t-111.5 -34t-139 -15.5 q-97 0 -178.5 44t-133.5 117t-81 164t-29 187q0 111 27.5 208.5t81 175.5t142.5 123.5t202 45.5zM532 905q-182 0 -235 -270h422q-3 45 -12.5 87.5t-29.5 86t-57.5 70t-87.5 26.5zM455 1292q0 -47 -30.5 -79.5t-72.5 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5t71.5 33.5 t72 -33.5t31 -79.5zM831 1292q0 -47 -30 -79.5t-72 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5t71.5 33.5t71.5 -33.5t30.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10099",
    unicode: "\u0452",
    horizAdvX: 1183,
    d: "M1001 725v-438q0 -348 -223 -348q-20 0 -46.5 5.5t-43.5 11.5l-16 5l-27 166q51 -21 90 -21q94 0 94 181v233q0 157 -29.5 222t-119.5 65q-60 0 -114.5 -15.5t-89 -38t-60.5 -45t-38 -38.5l-11 -15v-501l20 -154h-192v1157h-154v143h154v35l-27 189l199 22v-246h329v-143 h-329v-350q65 71 165.5 115.5t200.5 44.5q110 0 189 -63t79 -179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10100",
    unicode: "\u0453",
    horizAdvX: 813,
    d: "M168 1008h604v-144h-412v-710l21 -154h-193v854zM616 1440h226l-367 -334l-113 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10101",
    unicode: "\u0454",
    horizAdvX: 983,
    d: "M657 586v-144h-372q15 -142 84 -226.5t202 -84.5q49 0 98.5 14.5t85.5 34.5t65 40.5t44 35.5l15 14l28 -155q-5 -6 -15.5 -15.5t-47 -34t-77.5 -43t-107.5 -34t-137.5 -15.5q-82 0 -151 27t-118.5 74.5t-84 112t-51.5 140t-17 158.5q0 118 29 217t85.5 175t148.5 118.5 t210 42.5q216 0 334 -143l-108 -137q-96 137 -230 137q-127 0 -198.5 -84t-85.5 -225h372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10102",
    unicode: "\u0455",
    horizAdvX: 874,
    d: "M111 92l18 166q5 -6 14 -15t38.5 -32.5t61 -41.5t80 -33t97.5 -15q81 0 130.5 32.5t49.5 104.5q0 37 -27.5 68t-71.5 54.5t-97.5 47t-107 51.5t-97.5 61.5t-71.5 84t-27.5 112.5q0 136 97 218.5t245 82.5q181 0 295 -69l-49 -164q-100 102 -262 102q-63 0 -107.5 -35 t-44.5 -86q0 -44 27.5 -79t71.5 -59t97.5 -47t107 -50t97.5 -60.5t71.5 -86t27.5 -119.5q0 -138 -97.5 -225t-258.5 -87q-59 0 -112 12.5t-87 30t-59.5 34.5t-37.5 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10103",
    unicode: "\u0456",
    horizAdvX: 561,
    d: "M164 1313q0 43 31 74.5t75 31.5q42 0 73.5 -31.5t31.5 -74.5t-32 -77t-73 -34q-43 0 -74.5 33.5t-31.5 77.5zM367 1030v-876l20 -154h-192v819l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10104",
    unicode: "\u0457",
    horizAdvX: 561,
    d: "M367 1030v-876l20 -154h-192v819l-27 189zM195 1292q0 -47 -30.5 -79.5t-72.5 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5t71.5 33.5t72 -33.5t31 -79.5zM571 1292q0 -47 -30 -79.5t-72 -32.5t-72 32.5t-30 79.5q0 46 30.5 79.5t71.5 33.5t71.5 -33.5t30.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10105",
    unicode: "\u0458",
    horizAdvX: 552,
    d: "M164 1313q0 43 31 74.5t75 31.5q42 0 73.5 -31.5t31.5 -74.5t-32 -77t-73 -34q-43 0 -74.5 33.5t-31.5 77.5zM367 1030v-1055q0 -211 -96 -341t-244 -132l-68 142q236 0 236 331v844l-27 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10106",
    unicode: "\u0459",
    horizAdvX: 1488,
    d: "M909 1008v-369h103q415 0 415 -320q0 -319 -415 -319h-275v868h-291l-6 -168q-2 -63 -4.5 -107.5t-8 -109t-12.5 -111t-19 -103t-27.5 -96.5t-38.5 -80t-51 -64.5t-65 -40t-81 -15.5q-43 0 -94 15l-19 159q35 -12 76 -12q32 0 57 18.5t42.5 57.5t29.5 84.5t20 114 t12.5 131t8.5 149.5l8 168l-20 150h655zM1030 504h-121v-369h121q122 0 172.5 49t50.5 135t-50.5 135.5t-172.5 49.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10107",
    unicode: "\u045A",
    horizAdvX: 1529,
    d: "M950 1030v-424h103q114 0 197 -24t129.5 -67t67.5 -95t21 -117t-21 -117t-67.5 -95t-129.5 -67t-197 -24h-275v467h-411v-313l20 -154h-192v819l-27 189l199 22v-424h411v213l-26 189zM1071 471h-121v-336h121q223 0 223 168t-223 168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10108",
    unicode: "\u045B",
    horizAdvX: 1183,
    d: "M41 1157v143h154v35l-27 189l199 22v-246h329v-143h-329v-350q65 71 165.5 115.5t200.5 44.5q110 0 189 -63t79 -179v-575l21 -150h-193v520q0 157 -29.5 222t-119.5 65q-60 0 -114.5 -15.5t-89 -38t-60.5 -45t-38 -38.5l-11 -15v-501l20 -154h-192v1157h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10109",
    unicode: "\u045C",
    horizAdvX: 1056,
    d: "M367 1030v-455h110l146 246q66 111 136.5 157t155.5 46q42 0 74 -12l19 -152q-19 8 -60 8q-102 0 -174 -123l-139 -231l397 -514h-223l-334 436h-108v-282l20 -154h-192v819l-27 189zM694 1440h226l-367 -334l-113 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10110",
    unicode: "\u045E",
    horizAdvX: 972,
    d: "M961 1034l-484 -1206q-63 -157 -161.5 -241.5t-209.5 -84.5q-45 0 -106 23l-29 174q61 -21 105 -21q83 0 153 54.5t111 163.5l43 112l-281 830l-90 170l201 26l240 -682l26 -149l43 149l258 656zM514 1247q37 0 68.5 17t50 41.5t32 49t18.5 41.5l5 17l111 -37 q-2 -10 -7.5 -27.5t-28 -62t-51.5 -78.5t-82 -62t-116 -28t-115.5 26.5t-82.5 64.5t-51 76t-29 65l-7 26l111 37q2 -7 5.5 -18t18 -39.5t32.5 -50.5t49.5 -40t68.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10193",
    unicode: "\u045F",
    horizAdvX: 1191,
    d: "M1004 0h-322v-297h-172v297h-342l20 150v858h193l-21 -154v-715h471v869h193l-20 -150v-858z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10050",
    unicode: "\u0490",
    horizAdvX: 921,
    d: "M229 1159l-26 189h536v157h164v-313h-489v-1038l20 -154h-205v1159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10098",
    unicode: "\u0491",
    horizAdvX: 813,
    d: "M168 1008h455v161h149v-305h-412v-710l21 -154h-193v854z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 925,
    d: "M63 582h814l-41 -152h-773v152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1390,
    d: "M63 582h1276l-41 -152h-1235v152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 552,
    d: "M356 1380l74 -71q-42 -40 -78.5 -99.5t-36.5 -105.5q0 -39 16 -58.5t58 -37.5q0 -65 -31 -106.5t-92 -41.5q-51 0 -87 38.5t-36 109.5q0 88 55 196t158 176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 552,
    d: "M197 860l-74 72q42 40 78.5 99.5t36.5 105.5q0 39 -16 58.5t-58 37.5v18q0 55 34 92t89 37q51 0 87 -38t36 -109q0 -89 -55 -197t-158 -176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 552,
    d: "M197 -289l-74 72q42 40 78.5 99.5t36.5 105.5q0 39 -16 58.5t-58 37.5v18q0 55 34 92t89 37q51 0 87 -38t36 -109q0 -89 -55 -197t-158 -176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 911,
    d: "M356 1380l74 -71q-42 -40 -78.5 -99.5t-36.5 -105.5q0 -39 16 -58.5t58 -37.5q0 -65 -31 -106.5t-92 -41.5q-51 0 -87 38.5t-36 109.5q0 88 55 196t158 176zM715 1380l73 -71q-42 -40 -78 -99t-36 -106q0 -39 16 -58.5t58 -37.5q0 -65 -31 -106.5t-92 -41.5 q-51 0 -87 38.5t-36 109.5q0 88 55 196t158 176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 911,
    d: "M197 860l-74 72q42 40 78.5 99.5t36.5 105.5q0 39 -16 58.5t-58 37.5v18q0 55 34 92t89 37q51 0 87 -38t36 -109q0 -89 -55 -197t-158 -176zM555 860l-74 72q42 40 78.5 99.5t36.5 105.5q0 39 -16 58.5t-58 37.5v18q0 55 34 92t89 37q51 0 87 -38t36 -109q0 -89 -55 -197 t-158 -176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 911,
    d: "M197 -289l-74 72q42 40 78.5 99.5t36.5 105.5q0 39 -16 58.5t-58 37.5v18q0 55 34 92t89 37q51 0 87 -38t36 -109q0 -89 -55 -197t-158 -176zM555 -289l-74 72q42 40 78.5 99.5t36.5 105.5q0 39 -16 58.5t-58 37.5v18q0 55 34 92t89 37q51 0 87 -38t36 -109 q0 -89 -55 -197t-158 -176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 997,
    d: "M541 -502h-170v1370h-265v140h265v323l170 23v-346h333l-61 -140h-272v-1370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 997,
    d: "M541 -502h-170v502h-265v139h265v729h-265v140h265v323l170 23v-346h333l-61 -140h-272v-729h307l-62 -139h-245v-502z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 868,
    d: "M432 776q113 0 193 -79t80 -191q0 -115 -80 -195t-193 -80q-115 0 -194.5 79.5t-79.5 195.5q0 113 79.5 191.5t194.5 78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1357,
    d: "M377 84q0 -46 -32.5 -78.5t-76.5 -32.5q-46 0 -78 32.5t-32 78.5q0 44 32 76.5t78 32.5q44 0 76.5 -32.5t32.5 -76.5zM797 84q0 -46 -32.5 -78.5t-76.5 -32.5q-46 0 -78 32.5t-32 78.5q0 44 32 76.5t78 32.5q44 0 76.5 -32.5t32.5 -76.5zM1206 84q0 -46 -32 -78.5 t-76 -32.5q-46 0 -78.5 32.5t-32.5 78.5q0 44 32.5 76.5t78.5 32.5q44 0 76 -32.5t32 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 2375,
    d: "M756 1038q0 -125 -94 -216t-220 -91q-123 0 -215 91t-92 216t92.5 216.5t214.5 91.5q125 0 219.5 -91.5t94.5 -216.5zM635 1042q0 74 -59 129.5t-132 55.5q-76 0 -132 -55t-56 -130q0 -74 54.5 -136t133.5 -62q86 0 138.5 61t52.5 137zM1524 281q0 -125 -94.5 -216.5 t-219.5 -91.5q-122 0 -214.5 91.5t-92.5 216.5t92 216t215 91q126 0 220 -91t94 -216zM1403 285q0 74 -59 129t-132 55q-77 0 -132.5 -54.5t-55.5 -129.5q0 -74 55 -136.5t133 -62.5q86 0 138.5 61.5t52.5 137.5zM1360 1325l-918 -1325h-157l934 1380zM2247 281 q0 -125 -94.5 -216.5t-219.5 -91.5q-122 0 -214.5 91.5t-92.5 216.5t92 216t215 91q126 0 220 -91t94 -216zM2126 285q0 74 -59 129t-132 55q-77 0 -132.5 -54.5t-55.5 -129.5q0 -74 55 -136.5t133 -62.5q86 0 138.5 61.5t52.5 137.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 761,
    d: "M659 844l-354 -340l354 -336l-79 -131l-498 469l498 469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 761,
    d: "M457 504l-355 340l80 131l498 -469l-498 -469l-80 131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 1044,
    d: "M1087 1331l-921 -1331h-174l954 1386z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 1230,
    d: "M39 891h131q62 227 228 354t384 127q91 0 185 -22.5t157 -63.5l-49 -151q-124 96 -309 96q-144 0 -258.5 -92.5t-167.5 -247.5h649l-47 -141h-633q-4 -46 -4 -84q0 -32 4 -86h578l-47 -142h-504q45 -151 152.5 -233t271.5 -82q86 0 178 30t158 85v-162 q-162 -103 -373 -103q-204 0 -357 121t-204 344h-123v142h102q-2 20 -2 65q0 35 4 105h-104v141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 2125,
    d: "M1325 1348v-1194l12 -154h-96l-768 860l-88 133v-839l21 -154h-189v1159l-27 189h125l752 -852l90 -134v797l-27 189h195zM2075 1040q0 -125 -94 -216t-220 -91q-123 0 -215 91t-92 216t92.5 216.5t214.5 91.5q125 0 219.5 -91.5t94.5 -216.5zM1954 1044q0 74 -59 129.5 t-132 55.5q-76 0 -132 -55t-56 -130q0 -74 54.5 -136t133.5 -62q86 0 138.5 61t52.5 137zM1483 512v121h563v-121h-563z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 1642,
    d: "M55 1346v98h633v-98h-246v-578l13 -94h-158v672h-242zM1155 739l-285 389v-360l13 -94h-138v659l-14 111h90l340 -481l305 481h88v-676l13 -94h-158v461z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "A",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "J",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "Q",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "O",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "G",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "C",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "Q",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "O",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "G",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "C",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "W",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "T",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "O",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "G",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "C",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Y",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xFF",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xFD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xDD",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "W",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "T",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "T",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 311
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0153",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEA",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 311
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\"",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201D",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201C",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2019",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2018",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "T",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "'",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Y",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xEB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xEA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xE9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xE8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xDD",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "W",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "T",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "y",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "o",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "e",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "a",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "A",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ":",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0153",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFF",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFD",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF6",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF5",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF4",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF3",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF2",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEB",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEA",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE9",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE8",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE6",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE5",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE4",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE3",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE2",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE1",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE0",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "w",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "u",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "s",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "r",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "i",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "c",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "T",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "Q",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "O",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "G",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "C",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ";",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFF",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "i",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ";",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "y",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "o",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "e",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "a",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ":",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0153",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFF",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFD",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF6",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEA",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE8",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE6",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE1",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC0",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "u",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "r",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "i",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "c",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ";",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "-",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0153",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF5",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF4",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF3",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF2",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEB",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEA",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE9",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE8",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE5",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE3",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE2",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE1",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE0",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC0",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "z",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "w",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "u",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "t",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "s",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "n",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "m",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "c",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "-",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "J",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ",",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ".",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ",",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u0153",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xEB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xEA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "-",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "J",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "T",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "T",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "T",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "T",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "T",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "T",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "o",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "e",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "a",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "A",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ":",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ",",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0153",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF6",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF5",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF4",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF3",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF2",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEB",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEA",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE9",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE8",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE5",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE4",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE3",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE2",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE1",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE0",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC0",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "z",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "w",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "u",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "t",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "s",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "q",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "p",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "n",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "m",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "c",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ";",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ".",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "-",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ",",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ",",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0423",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0416",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0421",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0442",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0424",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0423",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0422",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0416",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u040E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0443",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0441",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0433",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0421",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ",",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0491",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u045E",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u045C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u045A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0459",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0454",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0453",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0451",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044F",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044D",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044B",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0449",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0448",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0446",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0445",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0444",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0442",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0440",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043F",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043D",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043B",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0439",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0438",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0437",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0436",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0435",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0434",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0432",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0431",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0430",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u042F",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0424",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u041B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0414",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0410",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ".",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0443",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0423",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u045E",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0422",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u040E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u040B",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0402",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0422",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u042A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u040B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0402",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0443",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0441",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0421",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ",",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u045E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u045C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u045A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0459",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0454",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0451",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044F",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044D",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044B",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0449",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0447",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0446",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0445",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0444",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0440",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043F",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043E",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043D",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043B",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0439",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0438",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0437",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0436",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0435",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0434",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0432",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0431",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0430",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0424",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u041B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0414",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0410",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0404",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ".",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0427",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0421",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0421",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0447",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0424",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0422",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0441",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0454",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0451",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0444",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043B",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0435",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0442",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0424",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0443",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0441",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042A",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0421",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ",",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0459",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0454",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0451",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044B",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0449",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0446",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0444",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0440",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043F",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043E",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043D",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043B",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0439",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0438",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0435",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0432",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0431",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0422",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040B",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0402",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ".",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0491",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u045E",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u045C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u045A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0459",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0454",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0453",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0451",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044F",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044D",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044B",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0449",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0448",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0446",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0445",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0444",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0442",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0440",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043F",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043D",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043B",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0439",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0438",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0437",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0436",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0435",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0434",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0432",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0431",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0430",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u042F",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0424",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u041B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0414",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0410",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: ".",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042A",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0423",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0421",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0422",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u041E",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0414",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u040E",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u040B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0404",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0402",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0427",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0427",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0422",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0416",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u040E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0423",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0422",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0416",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u042D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0422",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0422",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0443",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u045E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0445",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u043B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0436",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0431",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ",",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u043B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0434",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ".",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0437",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ",",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u043B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0434",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ".",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0454",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u043B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0434",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u043B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0437",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0436",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0443",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u045E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0442",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0443",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u045E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0442",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0441",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: ",",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0454",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u043B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0434",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "A",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "A",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u2019",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "Q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "O",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "G",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "C",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "A",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "Q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "O",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "G",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "C",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V,W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Y,Yacute",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v,w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "y,yacute,ydieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "comma,period",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "colon,semicolon",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute",
    g2: "v,w",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oe",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute",
    g2: "comma,period",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute",
    g2: "colon,semicolon",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w",
    g2: "comma,period",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "comma,period",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10051,afii10060,afii10044",
    g2: "afii10062,afii10037",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10051,afii10060,afii10044",
    g2: "afii10051,afii10060,afii10044",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "comma,period",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10053,afii10035",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10068,afii10100,afii10098",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10076,afii10109",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10083,afii10101",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10085,afii10110",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10094,afii10106,afii10107",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110",
    g2: "comma,period",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110",
    g2: "afii10083,afii10101",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035",
    g2: "afii10053,afii10035",
    k: 41
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsetFontinSansCrRegular);
export default __webpack_public_path__ + "static/media/subset-FontinSansCR-Regular.a2ef8970a470ff4a53d2d4eccd996079.svg";
export { ForwardRef as ReactComponent };